<template>
  <div class="mt-3">

    <div id="divResumen" v-show="showResumen">
    <div class="row text-center mb-5 container-fluid" style="margin-bottom: 1rem !important;">
      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-database me-2 bg-circle-1"></i> <span> {{ archivo.filasProcesadas }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('lineas_procesadas') }}
          </p>
        </div>
      </div>

      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-compress-arrows-alt me-2 bg-circle-4"></i> <span> {{ archivo.itemsConsolidados }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('lineas_consolidadas') }}
          </p>
        </div>
      </div>

      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-edit me-2 bg-circle-5"></i> <span> {{ archivo.actualizadasManualmente }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('actualizadas_manual') }}
          </p>
        </div>
      </div>
    </div>

    <div class="row text-center mb-5 container-fluid">

      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-tools me-2 bg-circle-3"></i> <span> {{ archivo.equipos }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('equipos') }}
          </p>
        </div>
      </div>

      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-tools me-2 bg-circle-3"></i> <span> {{ archivo.componentes }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('componentes') }}
          </p>
        </div>
      </div>
      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-tools me-2 bg-circle-3"></i> <span> {{ archivo.repuestos }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('repuestos') }}
          </p>
        </div>
      </div>
      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-tools me-2 bg-circle-3"></i> <span> {{ archivo.insumos }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('insumos') }}
          </p>
        </div>
      </div>

      <div class="col mb-4">
        <div class="card shadow-sm p-3 bg-white">
          <h4 class="text-primary c-grey">
            <i class="fas fa-tools me-2 bg-circle-3"></i> <span> {{ archivo.mobiliarios }}</span>
          </h4>
          <p class="text-muted">
            {{ $t('mobiliarios') }}
          </p>
        </div>
      </div>


    </div>
    </div><!-- /divResumen -->

    <div class="col-12 mt-4 container-fluid">
      
      <div class="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">

        <div class="d-flex flex-column">
          <h2 class="fw-bold mb-0 text-start">
             {{ $t('optimizacion_inventario') }}
          </h2>
          <h2 class="text-secondary mb-0" style="font-weight: normal; font-size: 1rem;">
            {{ $t('para_el_archivo') }} : <span style="color:red" class="fw-bold">{{ archivo.nombreXLSX }}</span>
          </h2>
        </div>

        <div class="d-flex align-items-end gap-2 flex-wrap">

          <!-- El archivo se puede consultar, pero su estado ya no admite cambios -->
          <div v-if="esArchivoSoloLectura" class="alerta-solo-lectura d-flex align-items-center gap-2" role="status">
            <i class="fas fa-lock"></i>
            <span>{{ $t('archivo_solo_lectura') }} ({{ etiquetaEstadoArchivo }})</span>
          </div>

          <!-- Aviso de cambios pendientes: acompaña a las filas marcadas en amarillo -->
          <div v-if="hayCambiosSinGuardar" class="alerta-sin-guardar d-flex align-items-center gap-2" role="status">
            <i class="fas fa-exclamation-circle icono-palpita"></i>
            <span>{{ $t('cambios_sin_guardar_aviso', { n: cantidadCambiosSinGuardar }) }}</span>
          </div>

          <div class="d-flex flex-column align-items-start">
            <label class="fw-bold mb-1" style="font-size:0.75rem;">{{ $t('filtrar_por') || 'Filtrar por' }}</label>
            <el-select v-model="filterColor" @change="onFiltersChange" class="w-auto select-compact" :placeholder="$t('seleccione')">
              <el-option label="Todos" value="all" />
              <el-option label="Verdes (≥80%)" value="green" />
              <el-option label="Amarillos (41–79%)" value="yellow" />
              <el-option label="Rojos (<41%)" value="red" />
              <el-option label="Manuales" value="manual" />
            </el-select>
          </div>

          <div class="d-flex flex-column align-items-start">
            <label class="fw-bold mb-1" style="font-size:0.75rem;">{{ $t('orden') || 'Orden' }}</label>
            <el-select v-model="sortMode" @change="onFiltersChange" class="w-auto select-compact" :placeholder="$t('seleccione')">
              <el-option label="Fijo (no reordenar)" value="none" />
              <el-option label="Por color y % (global)" value="confidence" />
            </el-select>
          </div>

          <button v-if="puedeEditarArchivo" class="btn btn-green btn-sm shadow-sm" @click="confirmGuardar" :disabled="isSaving || isPageLoading">
            <i class="fas fa-save me-1"></i> {{ $t('guardar_cambios') }}
          </button>

          <button class="btn btn-info btn-sm shadow-sm" @click="showResumen = !showResumen">
            <i class="fas fa-chart-bar me-2"></i> {{ showResumen ? $t('ocultar_resumen') : $t('ver_resumen') }}
          </button>

          <button class="btn btn-green btn-sm shadow-sm" @click="exportFile"
            :disabled="isSaving || isPageLoading">
            <i class="fas fa-file-export me-2"></i> XLS
          </button>

          <button
            v-if="puedeEditarArchivo && !esFlujoDirectoCluster && (!archivo.estadoFlujo || archivo.estadoFlujo === 'P')"
            class="btn btn-primary btn-sm shadow-sm"
            @click="$bvModal.show('modal-rentabilizar-result')"
            :disabled="isSaving || isPageLoading"
          >
            <i class="fas fa-chart-line me-1"></i> {{ $t('rentabilizar') || 'Rentabilizar' }}
          </button>

          <!-- Flujo "NR" (Directo a Cluster): no hay paso de rentabilización, la
               clusterización se dispara desde esta misma pantalla. -->
          <button
            v-if="puedeEditarArchivo && esFlujoDirectoCluster"
            class="btn btn-primary btn-sm shadow-sm"
            @click="$bvModal.show('modal-clusterizar-result')"
            :disabled="isSaving || isPageLoading"
          >
            <i class="fas fa-project-diagram me-1"></i> {{ $t('clusterizar') || 'Clusterizar' }}
          </button>

        </div>

      </div>
 
      <div class="table-responsive table-scroll-container" ref="tableWrapper">
        <table class="table table-striped" style="width: 100%; min-width: 1315px; table-layout: fixed; border: 1px solid #6c757d; border-radius: 4px;">
          <thead :class="['thead-sticky', showSelectedModal ? 'thead-behind-modal' : '']">
            <tr>
              <th @click="ordenar('skuInexlink')" class="th-ordenable" style="width: 80px;">
<input v-model.trim="searchId" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">SKU-INEX<br>{{ obtenerIconoOrden('skuInexlink') }}</span>
              </th>

              <th @click="ordenar('tipoMatch')" class="th-ordenable" style="width: 110px;">
                <input v-model.trim="searchTipoMatch" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">Match<br>{{ obtenerIconoOrden('tipoMatch') }}</span>
              </th>

              <th @click="ordenar('partNameOriginal')" class="th-ordenable highlight-column" style="width: 435px;">
                <input v-model.trim="searchPartName" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('nombre_corto') }}<br>{{ obtenerIconoOrden('partNameOriginal') }}</span>
              </th>

              <th @click="ordenar('detalles')" class="th-ordenable highlight-column2" style="width: 340px;">
                <input v-model.trim="searchDetalles" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('nombre_largo') }}<br>{{ obtenerIconoOrden('detalles') }}</span>
              </th>

              <th @click="ordenar('brandName')" class="th-ordenable" style="width: 140px;">
                <button v-if="puedeEditarArchivo" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="showBrandNameModal = true" :disabled="isSaving || isPageLoading">
                  <i class="fas fa-list me-1"></i> {{ $t('modificar_fabricante') }}
                </button>
                <input v-model.trim="searchBrandName" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('brand_name') }}<br>{{ obtenerIconoOrden('brandName') }}</span>
              </th>

              <th style="width: 25px;">
                <input type="checkbox" :disabled="!puedeEditarArchivo" @change="toggleAllChecksBrandName($event)" :checked="allCheckedBrandName" />
              </th>

              <th @click="ordenar('partNumber')" class="th-ordenable" style="width: 130px;">
                <input v-model.trim="searchPartNumber" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('part_number') }}<br>{{ obtenerIconoOrden('partNumber') }}</span>
              </th>

              <th @click="ordenar('modelo')" class="th-ordenable" style="width: 130px;">
                <input v-model.trim="searchModelo" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input"/>
                <span class="th-label">{{ $t('modelo') }}<br>{{ obtenerIconoOrden('modelo') }}</span>
              </th>

              <th @click="ordenar('categoriaOrigen')" class="th-ordenable" style="width: 130px;">
                <input v-model.trim="searchCategoriaOrigen" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input"/>
                <span class="th-label">{{ $t('categoria_origen') }}<br>{{ obtenerIconoOrden('categoriaOrigen') }}</span>
              </th>

              <th @click="ordenar('categoriaInexlink')" class="th-ordenable" style="width: 210px;">
                <div class="d-flex mb-1" style="gap: 4px;" @click.stop>
                  <button v-if="puedeEditarArchivo" class="btn btn-info btn-sm shadow-sm btn-modificar-categoria" @click.stop="showSelectedModal = true" :disabled="isSaving || isPageLoading">
                    <i class="fas fa-list me-1"></i> {{ $t('modificar_categoria') }}
                  </button>
                  <el-tooltip :content="$t('importar_categorias')" placement="top" effect="dark">
                    <button v-if="puedeEditarArchivo" class="btn btn-success btn-sm shadow-sm btn-importar-categoria" @click.stop="abrirImportCategorias" :disabled="isSaving || isPageLoading || isBulkApplying">
                      <i class="fas fa-file-upload"></i>
                    </button>
                  </el-tooltip>
                </div>
                <input v-model.trim="searchCategoriaInexlink" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">
                  {{ $t('categoria_inexlink') }}<br>{{ obtenerIconoOrden('categoriaInexlink') }}
                  <el-tooltip placement="top" effect="dark">
                    <template #content>
                      <div style="font-size: 0.8rem; line-height: 1.6;">
                        <div>{{ $t('leyenda_confianza_titulo') }}</div>
                        <div><span style="display:inline-block;width:10px;height:10px;background:#a1ebb2;border-radius:2px;margin-right:6px;"></span>{{ $t('leyenda_confianza_verde') }}</div>
                        <div><span style="display:inline-block;width:10px;height:10px;background:#ffedb6;border-radius:2px;margin-right:6px;"></span>{{ $t('leyenda_confianza_amarillo') }}</div>
                        <div><span style="display:inline-block;width:10px;height:10px;background:#ff9fa8;border-radius:2px;margin-right:6px;"></span>{{ $t('leyenda_confianza_rojo') }}</div>
                      </div>
                    </template>
                    <i class="fas fa-info-circle text-info" @click.stop style="cursor: pointer;"></i>
                  </el-tooltip>
                </span>
              </th>

              <th style="width: 25px;">
                <input type="checkbox" :disabled="!puedeEditarArchivo" @change="toggleAllChecks($event)" :checked="allChecked" />
              </th>

              <th @click="ordenar('clase')" class="th-ordenable" style="width: 140px;">
                <input v-model.trim="searchClase" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('cluster_clase') }}<br>{{ obtenerIconoOrden('clase') }}</span>
              </th>

              <th @click="ordenar('precio')" class="th-ordenable" style="width: 110px; text-align: right;">
                <input v-model.trim="searchPrecio" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('precio') || 'Valor Libro (USD)' }}<br>{{ obtenerIconoOrden('precio') }}</span>
              </th>

              <th @click="ordenar('cantidad')" class="th-ordenable" style="width: 70px; text-align: right;">
                <span class="th-label">{{ $t('cantidad') }}<br>{{ obtenerIconoOrden('cantidad') }}</span>
              </th>
              
              <th @click="ordenar('uom')" class="th-ordenable" style="width: 130px;">
                <button v-if="puedeEditarArchivo" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="showUomModal = true" :disabled="isSaving || isPageLoading">
                  <i class="fas fa-list me-1"></i> {{ $t('modificar_uom') }}
                </button>
                <input v-model.trim="searchUom" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('uom') }}<br>{{ obtenerIconoOrden('uom') }}</span>
              </th>

              <th style="width: 25px;">
                <input type="checkbox" :disabled="!puedeEditarArchivo" @change="toggleAllChecksUom($event)" :checked="allCheckedUom" />
              </th>

              <th @click="ordenar('condicion')" class="th-ordenable" style="width: 140px;">
                <button v-if="puedeEditarArchivo" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="showCondicionModal = true" :disabled="isSaving || isPageLoading">
                  <i class="fas fa-list me-1"></i> {{ $t('modificar_condicion') }}
                </button>
                <input v-model.trim="searchCondicion" @input="onFiltersChange" @click.stop type="text" class="form-control inpt_result inpt-partname th-search-input" />
                <span class="th-label">{{ $t('condicion') }}<br>{{ obtenerIconoOrden('condicion') }}</span>
              </th>

              <th style="width: 25px;">
                <input type="checkbox" :disabled="!puedeEditarArchivo" @change="toggleAllChecksCondicion($event)" :checked="allCheckedCondicion" />
              </th>

              <th style="width: 40px; text-align: center;"><i class="fas fa-info-circle text-secondary"></i></th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in etl" :key="item.idMaterialETL" :class="{ 'fila-modificada': filaModificada(item) }">

              <td :class="{ 'bg-danger': !item.skuInexlink }">
                <span class="d-block text-muted" style="font-size: 0.7rem; margin-top: 15px !important;">{{ item.skuInexlink != null ? item.skuInexlink : '' }}</span>
              </td>

              <td style="vertical-align: middle; text-align: center;">
                <span v-if="item.tipoMatch === 'S'" class="badge badge-pill badge-success">YES</span>
                <span v-else class="badge badge-pill badge-danger">NO</span>
              </td>

              <td :class="{ 'bg-danger': !item.partNameSugerido, 'celda-modificada': algunCampoModificado(item, ['partNameSugerido', 'ActPartNameBNPN']) }" class="highlight-column">

                <div class="d-flex align-items-center gap-1 mb-1">
                  S <el-tooltip :content="$t('sugerido') + ' : ' + item.partNameSugerido" placement="top"
                    :disabled="!item.partNameSugerido" effect="dark">
                    <input v-model="item.partNameSugerido" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result inpt-partname"
                      @input="item.showGuardar = true; item.ActPartNameBNPN = true" style="flex: 0 0 70%; max-width: 70%;" />
                  </el-tooltip>
                </div>

                <div class="d-flex align-items-center gap-1">
                  O <el-tooltip :content="$t('original') + ' : ' + item.partNameOriginal" placement="top"
                    :disabled="!item.partNameOriginal" effect="dark">
                    <input v-model="item.partNameOriginal" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result inpt-partname"
                      readonly style="flex: 0 0 70%; max-width: 70%; background-color: #f8f9fa;" />
                  </el-tooltip> &nbsp;
                  <label style="flex: 0 0 30%; display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-size: 0.65rem; white-space: nowrap;">
                    <input type="checkbox" :checked="!item.ActPartNameBNPN" :disabled="!puedeEditarArchivo" @change="item.ActPartNameBNPN = !$event.target.checked; item.showGuardar = true" style="margin: 0;" />
                    {{ $t('usar_original') }}
                  </label>
                </div>

              </td>
             
              <td :class="{ 'bg-danger': !item.detalles, 'celda-modificada': algunCampoModificado(item, ['detallesSugerido', 'ActDetallesBNPN']) }" class="highlight-column2">

                <div class="d-flex align-items-center gap-1 mb-1">
                  S <el-tooltip :content="$t('sugerido') + ' : ' + item.detallesSugerido" placement="top"
                    :disabled="!item.detallesSugerido" effect="dark">
                    <input v-model="item.detallesSugerido" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result inpt-partname"
                      @input="item.showGuardar = true; item.ActDetallesBNPN = true" style="flex: 0 0 70%; max-width: 70%;" />
                  </el-tooltip>
                </div>

                <div class="d-flex align-items-center gap-1">
                  O <el-tooltip :content="$t('original') + ' : ' + item.detallesOriginal" placement="top"
                    :disabled="!item.detallesOriginal" effect="dark">
                    <input v-model="item.detallesOriginal" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result inpt-partname"
                      readonly style="flex: 0 0 70%; max-width: 70%; background-color: #f8f9fa;" />
                  </el-tooltip> &nbsp;
                  <label style="flex: 0 0 30%; display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-size: 0.65rem; white-space: nowrap;">
                    <input type="checkbox" :checked="!item.ActDetallesBNPN" :disabled="!puedeEditarArchivo" @change="item.ActDetallesBNPN = !$event.target.checked; item.showGuardar = true" style="margin: 0;" />
                    {{ $t('usar_original') }}
                  </label>
                </div>

              </td>

              <td :class="{ 'bg-danger': !item.brandName, 'celda-modificada': campoModificado(item, 'brandName') }">
                <el-tooltip :content="item.brandName || '—'" placement="top" :disabled="!item.brandName" effect="dark">
                  <input v-model="item.brandName" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result"
                    @input="item.showGuardar = true" style="margin-top: 15px !important;" />
                </el-tooltip>
              </td>

              <td>
                <input type="checkbox" :disabled="!puedeEditarArchivo" :value="item.idMaterialETL" v-model="checkedIdsBrandName" />
              </td>

              <td :class="{ 'bg-danger': !item.partNumber, 'celda-modificada': campoModificado(item, 'partNumber') }">
                <el-tooltip :content="item.partNumber || '—'" placement="top" :disabled="!item.partNumber" effect="dark">
                  <input v-model="item.partNumber" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result"
                    @input="item.showGuardar = true" style="margin-top: 15px !important;" />
                </el-tooltip>
              </td>

              <td :class="{ 'celda-modificada': campoModificado(item, 'modelo') }">
                <el-tooltip :content="item.modelo || '—'" placement="top" :disabled="!item.modelo" effect="dark">
                  <input v-model="item.modelo" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result"
                    @input="item.showGuardar = true" style="margin-top: 15px !important;" />
                </el-tooltip>
              </td>

              <td :class="{ 'bg-danger': !item.categoriaOrigen, 'celda-modificada': campoModificado(item, 'categoriaOrigen') }">
                <el-tooltip :content="item.categoriaOrigen || '—'" placement="top" :disabled="!item.categoriaOrigen" effect="dark">
                  <input v-model="item.categoriaOrigen" type="text" :readonly="!puedeEditarArchivo" class="form-control inpt_result"
                    @input="item.showGuardar = true" style="margin-top: 15px !important;" />
                </el-tooltip>
              </td>

              <!-- Si hay cambio sin guardar, el amarillo de pendiente manda sobre el color de confianza -->
              <td :style="(campoModificado(item, 'categoriaInexlink') || isManualChoice(item)) ? {} : calcularColorPorConfianza(item.confianza)"
                :class="{ 'celda-modificada': campoModificado(item, 'categoriaInexlink') }"
                class="d-flex align-items-center">
                
                <el-tooltip effect="dark" :content="getPrediccionTexto(item)" placement="top" :manual="true" :value="item._tooltipVisible">
                  <div class="el-select-categoria" style="flex: 1;"
                    @mouseenter="$set(item, '_tooltipVisible', true)"
                    @mouseleave="$set(item, '_tooltipVisible', false)">
                    <el-select v-model="item.categoriaInexlink" :disabled="!puedeEditarArchivo" filterable clearable :placeholder="$t('seleccione')"
                      @change="onCategoriaChange(item)" style="width: 100%;">
                      <el-option-group :label="$t('sugeridas_ia') || 'Sugeridas por IA'">
                        <el-option v-for="c in getCategoryOptions(item).top5" :key="'ia-' + c.value"
                          :label="c.label" :value="c.value" class="opt-ia" />
                      </el-option-group>
                      <el-option-group :label="$t('todas_categorias') || 'Todas las categorías'">
                        <el-option v-for="c in getCategoryOptions(item).rest" :key="'all-' + c.value"
                          :label="c.label" :value="c.value" />
                      </el-option-group>
                    </el-select>
                  </div>
                </el-tooltip>
              </td>

              <td>
                <input type="checkbox" :disabled="!puedeEditarArchivo" :value="item.idMaterialETL" v-model="checkedIds" />
              </td>

               <td :class="{ 'bg-danger': !item.clase }">
                <span class="d-block text-muted" style="font-size: 0.7rem; margin-top: 15px !important;">{{ item.clase != null ? item.clase : '' }}</span>
              </td>

              <td style="text-align: right;">
                <span class="d-block text-muted" style="font-size: 0.7rem; margin-top: 15px !important;">{{ formatPrecio(item.precio) }}</span>
              </td>

               <td style="text-align: right;">
                <span class="d-block text-muted" style="font-size: 0.7rem; margin-top: 15px !important;">{{ item.cantidad != null ? item.cantidad : '' }}</span>
              </td>

              <td :class="{ 'bg-danger': !item.idUnidadDeMedida, 'celda-modificada': campoModificado(item, 'idUnidadDeMedida') }">
                <el-select v-model="item.idUnidadDeMedida" :disabled="!puedeEditarArchivo" filterable clearable :placeholder="$t('seleccione')"
                  @change="item.showGuardar = true" style="width: 100%;">
                  <el-option v-for="opt in unidadesMedidaOptions" :key="opt.id"
                    :label="uomOptionLabel(opt)"
                    :value="opt.id" />
                </el-select>
              </td>

              <td>
                <input type="checkbox" :disabled="!puedeEditarArchivo" :value="item.idMaterialETL" v-model="checkedIdsUom" />
              </td>

              <td :class="{ 'bg-danger': !item.idCondicion, 'celda-modificada': campoModificado(item, 'idCondicion') }">
                <el-select v-model="item.idCondicion" :disabled="!puedeEditarArchivo" clearable :placeholder="$t('seleccione')"
                  @change="item.showGuardar = true" style="width: 100%;">
                  <el-option v-for="opt in condicionesOptions" :key="opt.id"
                    :label="lang === 'en' ? opt.nombreIngles : opt.nombre"
                    :value="Number(opt.id)" />
                </el-select>
              </td>

              <td>
                <input type="checkbox" :disabled="!puedeEditarArchivo" :value="item.idMaterialETL" v-model="checkedIdsCondicion" />
              </td>

              <td style="text-align: center; vertical-align: middle;">
                <el-tooltip placement="left" effect="dark">
                  <template #content>
                    <div style="font-size: 0.8rem; line-height: 1.8; min-width: 260px;">
                      <div><b>ID ETL:</b> {{ item.idMaterialETL }}</div>
                      <div><b>SKU Inexlink:</b> {{ item.skuInexlink || '—' }}</div>
                      <div><b>{{ $t('nombre_corto') }} (S):</b> {{ item.partNameSugerido || '—' }}</div>
                      <div><b>{{ $t('nombre_corto') }} (O):</b> {{ item.partNameOriginal || '—' }}</div>
                      <div><b>{{ $t('nombre_largo') }} (S):</b> {{ item.detallesSugerido || '—' }}</div>
                      <div><b>{{ $t('nombre_largo') }} (O):</b> {{ item.detallesOriginal || '—' }}</div>
                      <div><b>{{ $t('brand_name') }}:</b> {{ item.brandName || '—' }}</div>
                      <div><b>{{ $t('part_number') }}:</b> {{ item.partNumber || '—' }}</div>
                      <div><b>{{ $t('categoria_origen') }}:</b> {{ item.categoriaOrigen || '—' }}</div>
                      <div><b>{{ $t('categoria_inexlink') }}:</b> {{ item.categoriaInexlink || '—' }}</div>
                      <div><b>{{ $t('cluster_clase') }}:</b> {{ item.clase || '—' }}</div>
                      <div><b>{{ $t('cantidad') }}:</b> {{ item.cantidad }}</div>
                      <div><b>{{ $t('uom') }}:</b> {{ getUomLabel(item) }}</div>
                    </div>
                  </template>
                  <i class="fas fa-info-circle text-info" style="cursor: pointer; font-size: 1rem; margin-top: 15px; display: block;"></i>
                </el-tooltip>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <!-- Barra flotante de paginación -->
      <div class="pagination-floating-bar">
        <div class="d-flex align-items-center">
          <label for="pageSize" class="me-2 fw-bold text-secondary mb-0">
            {{ $t('items_por_pagina') }}
          </label>
          <el-select id="pageSize" v-model="pageSize" @change="onChangePageSize" style="width: 80px"
            :placeholder="$t('seleccione')">
            <el-option v-for="size in [5, 10, 20, 50, 100]" :key="size" :label="size" :value="size" />
            <el-option :value="999999" label="Todos" />
          </el-select>
        </div>

        <div class="d-flex align-items-center gap-3">
          <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1"
            @click="setPage(currentPage - 1)">
            <i class="fas fa-arrow-left me-2"></i> {{ $t('anterior') }}
          </button>

          <span class="fw-bold text-secondary">
            {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
          </span>
          &nbsp;&nbsp;
          <button class="btn btn-outline-primary btn-sm" :disabled="currentPage === totalPages"
            @click="setPage(currentPage + 1)">
            {{ $t('siguiente') }} <i class="fas fa-arrow-right ms-2"></i>
          </button>

          <span class="fw-bold text-secondary">
            {{ totalCount }} {{ $t('items_totales') }}
          </span>
        </div>

        <div class="d-flex align-items-center gap-2">
          <button v-if="puedeEditarArchivo" class="btn btn-green btn-sm shadow-sm" @click="confirmGuardar" :disabled="isSaving || isPageLoading">
            <i class="fas fa-save me-1"></i> {{ $t('guardar_cambios') }}
          </button>
          <button class="btn btn-primary btn-sm shadow-sm" @click="refreshTable" :disabled="isSaving || isPageLoading">
            <i class="fas fa-sync-alt"></i>
          </button>
          <!-- Cuántas filas dejaron los filtros de la cabecera. Solo aparece cuando
               filtran algo: sin filtros repetiría el total que ya está a la izquierda. -->
          <span v-if="hayFiltroActivo" class="badge-filtrados" :title="$t('items_filtrados_ayuda')">
            <i class="fas fa-filter me-1"></i>{{ totalFiltrado }} {{ $t('items_filtrados') }}
          </span>
        </div>

        <!-- Controles de navegación de scroll -->
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" title="Scroll izquierda">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" title="Scroll derecha">
            <i class="fas fa-chevron-right"></i>
          </button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" title="Ir al inicio">
            <i class="fas fa-chevron-up"></i>
          </button>
          <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" title="Ir al final">
            <i class="fas fa-chevron-down"></i>
          </button>
        </div>
      </div>

      <!-- Modal para mostrar los IDs seleccionados y seleccionar categoría -->
      <b-modal v-model="showSelectedModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>

          <!-- <textarea class="form-control mb-3" rows="2" readonly>{{ checkedIdsString }}</textarea> -->

          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') || 'Aplicar a' }}</label>
          <b-form-radio-group v-model="categoriaApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') || 'Registros seleccionados' }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_archivo') || 'Todos los registros del archivo' }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nueva_categoria') }}</label>
          <el-select v-model="selectedCategoria" filterable clearable :placeholder="$t('seleccione')"
            style="width: 100%;">
            <el-option-group v-if="categoriasInexlinkModal.top5.length" :label="$t('sugeridas_ia') || 'Sugeridas por IA'">
              <el-option v-for="cat in categoriasInexlinkModal.top5" :key="'m-ia-' + cat.value"
                :label="cat.label" :value="cat.value" class="opt-ia" />
            </el-option-group>
            <el-option-group :label="$t('todas_categorias') || 'Todas las categorías'">
              <el-option v-for="cat in categoriasInexlinkModal.rest" :key="'m-all-' + cat.value"
                :label="cat.label" :value="cat.value" />
            </el-option-group>
          </el-select>

          <div v-if="categoriaApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos') || 'Esta acción actualiza de inmediato TODOS los registros del archivo, sin pasar por el guardado individual.' }}
          </div>

          <button v-if="puedeEditarArchivo" class="btn btn-primary mt-3" @click="aplicarCategoriaSeleccionada" :disabled="isBulkApplying">
            {{ $t('modal_aplicar_categoria') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal de importación masiva de categorías desde Excel -->
      <b-modal v-model="showImportCategoriasModal" :title="$t('importar_categorias')" hide-footer size="lg">
        <div>
          <p class="small text-muted mb-2">
            {{ $t('importar_categorias_ayuda') }}
          </p>

          <input ref="importCategoriasInput" type="file" accept=".xlsx,.xls"
            class="form-control mb-3" @change="onImportCategoriasFile" :disabled="isImportParsing || isBulkApplying" />

          <div v-if="isImportParsing" class="text-muted small">
            <i class="fas fa-spinner fa-spin me-1"></i> {{ $t('procesando') || 'Procesando…' }}
          </div>

          <div v-if="importError" class="alert alert-danger py-2 small mb-0">
            <i class="fas fa-exclamation-triangle me-1"></i> {{ importError }}
          </div>

          <!-- Resumen / preview -->
          <div v-if="importPreview && !isImportParsing && !importError">
            <table class="table table-sm table-bordered mb-2">
              <tbody>
                <tr>
                  <td>{{ $t('import_filas_leidas') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.totalLeidas }}</td>
                </tr>
                <tr class="table-success">
                  <td>{{ $t('import_filas_aplicables') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.aplicables }}</td>
                </tr>
                <tr v-if="importPreview.sinMatch > 0" class="table-warning">
                  <td>{{ $t('import_sin_match') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.sinMatch }}</td>
                </tr>
                <tr v-if="importPreview.categoriaInvalida > 0" class="table-warning">
                  <td>{{ $t('import_categoria_invalida') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.categoriaInvalida }}</td>
                </tr>
                <tr v-if="importPreview.duplicados > 0" class="table-warning">
                  <td>{{ $t('import_duplicados') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.duplicados }}</td>
                </tr>
                <tr v-if="importPreview.incompletas > 0" class="table-warning">
                  <td>{{ $t('import_incompletas') }}</td>
                  <td class="text-right fw-bold">{{ importPreview.incompletas }}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="importPreview.categoriasInvalidas.length" class="mb-2">
              <div class="small fw-bold text-danger mb-1">{{ $t('import_categorias_no_reconocidas') }}</div>
              <ul class="small text-muted mb-0" style="max-height: 130px; overflow-y: auto; padding-left: 18px;">
                <li v-for="(c, i) in importPreview.categoriasInvalidas" :key="'ci-' + i">{{ c }}</li>
              </ul>
            </div>

            <div v-if="importPreview.aplicables === 0" class="alert alert-warning py-2 small">
              {{ $t('import_nada_que_aplicar') }}
            </div>

            <button v-if="puedeEditarArchivo" class="btn btn-primary mt-2" :disabled="importPreview.aplicables === 0 || isBulkApplying"
              @click="aplicarImportCategorias">
              <i class="fas fa-check me-1"></i>
              {{ $t('import_aplicar') }} ({{ importPreview.aplicables }})
            </button>
          </div>
        </div>
      </b-modal>

      <!-- Modal para modificación masiva de Condición de Uso -->
      <b-modal v-model="showCondicionModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') || 'Aplicar a' }}</label>
          <b-form-radio-group v-model="condicionApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') || 'Registros seleccionados' }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_archivo') || 'Todos los registros del archivo' }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nueva_condicion') }}</label>
          <el-select v-model="selectedCondicion" filterable clearable :placeholder="$t('seleccione')"
            style="width: 100%;">
            <el-option v-for="opt in condicionesOptions" :key="opt.id"
              :label="lang === 'en' ? opt.nombreIngles : opt.nombre"
              :value="Number(opt.id)" />
          </el-select>

          <div v-if="condicionApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos') || 'Esta acción actualiza de inmediato TODOS los registros del archivo, sin pasar por el guardado individual.' }}
          </div>

          <button v-if="puedeEditarArchivo" class="btn btn-primary mt-3" @click="aplicarCondicionSeleccionada" :disabled="isBulkApplying">
            {{ $t('modal_aplicar_condicion') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal para modificación masiva de UOM -->
      <b-modal v-model="showUomModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') || 'Aplicar a' }}</label>
          <b-form-radio-group v-model="uomApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') || 'Registros seleccionados' }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_archivo') || 'Todos los registros del archivo' }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nueva_uom') }}</label>
          <el-select v-model="selectedUom" filterable clearable :placeholder="$t('seleccione')"
            style="width: 100%;">
            <el-option v-for="opt in unidadesMedidaOptions" :key="opt.id"
              :label="uomOptionLabel(opt)"
              :value="opt.id" />
          </el-select>

          <div v-if="uomApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos') || 'Esta acción actualiza de inmediato TODOS los registros del archivo, sin pasar por el guardado individual.' }}
          </div>

          <button v-if="puedeEditarArchivo" class="btn btn-primary mt-3" @click="aplicarUomSeleccionada" :disabled="isBulkApplying">
            {{ $t('modal_aplicar_uom') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal para modificación masiva de Fabricante (texto libre) -->
      <b-modal v-model="showBrandNameModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') || 'Aplicar a' }}</label>
          <b-form-radio-group v-model="brandNameApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') || 'Registros seleccionados' }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_archivo') || 'Todos los registros del archivo' }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nuevo_fabricante') }}</label>
          <input v-model.trim="selectedBrandName" type="text" class="form-control"
            :placeholder="$t('escriba_fabricante')" maxlength="150" @keyup.enter="aplicarBrandNameSeleccionada" />

          <!-- El campo vacío es válido: deja el fabricante en blanco en los registros indicados -->
          <div v-if="!selectedBrandName" class="text-muted small mt-2">
            <i class="fas fa-info-circle me-1"></i>
            {{ $t('aviso_fabricante_vacio') }}
          </div>

          <div v-if="brandNameApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos') || 'Esta acción actualiza de inmediato TODOS los registros del archivo, sin pasar por el guardado individual.' }}
          </div>

          <button v-if="puedeEditarArchivo" class="btn btn-primary mt-3" @click="aplicarBrandNameSeleccionada" :disabled="isBulkApplying">
            {{ $t('modal_aplicar_fabricante') }}
          </button>
        </div>
      </b-modal>
    </div>


    <!-- Overlay de carga -->
    <div v-if="isPageLoading" class="loading-backdrop">
      <div class="loading-box">
        <img src="/img/others/loading.gif" width="54" height="54" alt="loading" />
        <span style="margin-left:10px;">
          {{ loadingMessage || ($t('cargando') || 'Cargando...') }}
        </span>
      </div>
    </div>

    <b-modal
      id="modal-rentabilizar-result"
      :title="$t('confirmar_ejecucion') || 'Confirmar ejecución'"
      @ok="ejecutarRentabilizacion"
      :ok-title="$t('si_ejecutar') || 'Sí, ejecutar'"
      :cancel-title="$t('cancelar') || 'Cancelar'"
      ok-variant="danger"
    >
      <p>{{ $t('seguro_ejecutar') || '¿Está seguro de que desea ejecutar el proceso de rentabilización?' }}</p>
    </b-modal>

    <b-modal
      id="modal-clusterizar-result"
      :title="$t('confirmar_clusterizar') || '¿Iniciar clusterización?'"
      @ok="ejecutarClusterizacion"
      :ok-title="$t('si_ejecutar') || 'Sí, ejecutar'"
      :cancel-title="$t('cancelar') || 'Cancelar'"
      ok-variant="danger"
    >
      <p>{{ $t('confirmar_clusterizar_texto') || 'Se enviará el archivo a clusterización.' }}</p>
    </b-modal>
  </div>
</template>

<script>
import { Select, Option, OptionGroup } from 'element-ui';
import materialService from "@/api/materialService";
import diccionarioService from "@/api/diccionarioService";
import unidadMedidaService from "@/api/unidadMedidaService";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

// Marca los errores de carga por bloque para distinguirlos, en el catch general,
// de cualquier otro fallo: solo en este caso hay riesgo de datos incompletos.
const BLOQUE_ETL_FALLIDO = 'BLOQUE_ETL_FALLIDO:';

// Campos editables de la tabla. Se comparan contra el snapshot `_orig` de cada fila
// para pintar en amarillo lo que todavía no se ha guardado en la base de datos.
const CAMPOS_EDITABLES = [
  'partNameSugerido',
  'ActPartNameBNPN',
  'detallesSugerido',
  'ActDetallesBNPN',
  'brandName',
  'partNumber',
  'modelo',
  'categoriaOrigen',
  'categoriaInexlink',
  'idUnidadDeMedida',
  'idCondicion',
];

// Estados de flujo en los que el archivo todavía admite edición. Es el mismo
// criterio que usa la lista de /materiales (MaterialesView.vue) para decidir si el
// nombre del archivo abre esta pantalla: P (pendiente), R (rentabilizado),
// C (clusterizando) y T (clusterizado). Con I (ingresado), J/K/L (errores) y
// E (publicado en e-commerce) la pantalla se abre igual, pero en solo lectura.
const ESTADOS_EDITABLES = ['P', 'R', 'C', 'T'];

// Normaliza para comparar: null/undefined/'' son equivalentes y los tipos no importan
// (el id de UOM puede llegar como número o string según el origen del dato).
const valorComparable = (v) => {
  if (v === undefined || v === null) return '';
  if (typeof v === 'boolean') return v ? '1' : '0';
  return String(v).trim();
};

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
  },
  data() {
    return {
      empresaId: null,
      loadingMessage: '',
      searchId: '',
      searchTipoMatch: '',
      freezeOrder: false,
      searchBrandName: '',
      searchPartNumber: '',
      searchPartName: '',
      searchDetalles: '',
      searchModelo: '',
      searchCategoriaOrigen: '',
      searchCategoriaInexlink: '',
      searchClase: '',
      searchPrecio: '',
      searchCondicion: '',
      searchUom: '',
      orderLock: [], // IDs en el orden visible (snapshot)
      etl: [],            // solo la página visible
      etlAll: [],         // TODOS los registros
      //sortedAll: [],      // TODOS ordenados (verde→amarillo→rojo y por %)
      initialEtl: [], // Guardamos los datos iniciales para comparación
      // Registros que quedan tras los filtros de la cabecera. Se guarda el largo y no
      // el arreglo: sortedAll no se declara en data para no hacer reactivo un arreglo
      // de miles de filas, y un numero si es barato de observar.
      totalFiltrado: 0,
      currentPage: 1,
      pageSize: 100,
      totalPages: 1,
      totalCount: 0,
      checkedIds: [],
      showSelectedModal: false,
      selectedCategoria: null,
      categoriaApplyScope: 'selected', // 'selected' | 'all'
      checkedIdsCondicion: [],
      showCondicionModal: false,
      selectedCondicion: null,
      condicionApplyScope: 'selected', // 'selected' | 'all'
      checkedIdsUom: [],
      showUomModal: false,
      selectedUom: null,
      uomApplyScope: 'selected', // 'selected' | 'all'
      checkedIdsBrandName: [],
      showBrandNameModal: false,
      selectedBrandName: '',     // texto libre, no hay catálogo de fabricantes
      brandNameApplyScope: 'selected', // 'selected' | 'all'
      unidadesMedidaOptions: [],
      isBulkApplying: false, // update masivo por Token en curso
      // Importación masiva de categorías desde Excel
      showImportCategoriasModal: false,
      isImportParsing: false,
      importError: null,
      importPreview: null,   // { totalLeidas, aplicables, sinMatch, categoriaInvalida, duplicados, incompletas, categoriasInvalidas[], filas[] }
      sortMode: 'confidence',     // 'none' = no reordenar; 'confidence' = color→% (global)
      filterColor: 'all',
      isPageLoading: false, // overlay de carga/refresh
      isSaving: false,      // estado de guardado (sin overlay)
      showResumen: false,   // toggle panel de resumen estadístico
      taxByCategoria: Object.create(null), // { 'BOMBAS CENTRIFUGAS': {Clase, Segmento, Familia} }
      archivo: {
        nombreXLSX: '',
        filasProcesadas: 0,
        itemsConsolidados: 0,
        actualizadasManualmente: 0,
        equipos: 0,
        componentes: 0,
        repuestos: 0,
        insumos: 0,
        mobiliarios: 0,
        estadoFlujo: null,
        estadoFlujoDesc: '',
        estadoFlujoDescEn: '',
        tipoFlujo: '',
      },
      // Ordenamiento de tabla
      ordenColumna: null,
      ordenDireccion: 'asc',
      condicionesOptions: [],
      lang: localStorage.getItem('language') || 'es',
    };
  },
  computed: {
    // Los filtros de la cabecera de la tabla, para saber si el conteo filtrado
    // aporta algo distinto del total del archivo.
    hayFiltroActivo() {
      if (this.filterColor !== 'all') return true;
      return [
        this.searchId, this.searchTipoMatch, this.searchBrandName, this.searchPartNumber,
        this.searchPartName, this.searchDetalles, this.searchModelo, this.searchCategoriaOrigen,
        this.searchCategoriaInexlink, this.searchClase, this.searchPrecio, this.searchCondicion,
        this.searchUom,
      ].some(v => String(v == null ? '' : v).trim() !== '');
    },
    estadoArchivo() {
      return String((this.archivo && this.archivo.estadoFlujo) || '').trim().toUpperCase();
    },
    // Mientras el log no llegue, el estado viene vacío y no se bloquea nada: si el
    // endpoint falla preferimos dejar la pantalla como estaba antes en vez de
    // congelar la edición por un problema de red.
    esArchivoSoloLectura() {
      return !!this.estadoArchivo && !ESTADOS_EDITABLES.includes(this.estadoArchivo);
    },
    // Reemplaza a puedeEscribir en toda la pantalla: además del rol, exige que el
    // archivo esté en un estado que admita cambios.
    puedeEditarArchivo() {
      return this.puedeEscribir && !this.esArchivoSoloLectura;
    },
    // Descripción del estado que ya envía el backend (dbo.EstadosProceso).
    etiquetaEstadoArchivo() {
      const a = this.archivo || {};
      const desc = this.lang === 'en'
        ? (a.estadoFlujoDescEn || a.estadoFlujoDesc)
        : a.estadoFlujoDesc;
      return desc || this.estadoArchivo;
    },
    // "NR" = Directo a Cluster: este archivo no pasa por rentabilización, así que
    // la clusterización se lanza desde aquí y no desde la pantalla de rentabilización.
    esFlujoDirectoCluster() {
      return String((this.archivo && this.archivo.tipoFlujo) || '').trim().toUpperCase() === 'NR';
    },
    checkedIdsString() {
      return this.checkedIds.join(';');
    },
    allChecked() {
      return this.etl.length > 0 && this.checkedIds.length === this.etl.length;
    },
    allCheckedCondicion() {
      return this.etl.length > 0 && this.checkedIdsCondicion.length === this.etl.length;
    },
    allCheckedUom() {
      return this.etl.length > 0 && this.checkedIdsUom.length === this.etl.length;
    },
    allCheckedBrandName() {
      return this.etl.length > 0 && this.checkedIdsBrandName.length === this.etl.length;
    },
    // Cuenta sobre TODAS las filas cargadas, no solo la página visible: los cambios de
    // otras páginas siguen vivos en memoria porque etl es un slice por referencia.
    cantidadCambiosSinGuardar() {
      const lista = (this.etlAll && this.etlAll.length) ? this.etlAll : this.etl;
      return lista.filter(it => it && it.showGuardar).length;
    },
    hayCambiosSinGuardar() {
      return this.cantidadCambiosSinGuardar > 0;
    },
    allCategoriasSorted() {
      const locale = this.lang === 'en' ? 'en' : 'es';
      return Object.keys(this.taxByCategoria)
        .sort((a, b) => this._catLabel(a).localeCompare(this._catLabel(b), locale, { sensitivity: 'base' }));
    },
    categoriasInexlinkModal() {
      const seleccionados = this.etl.filter(item => this.checkedIds.includes(item.idMaterialETL));
      const top5Set = new Set();
      const top5 = [];
      seleccionados.forEach(item => {
        this.parseTop5Predicciones(item.top5Predicciones).forEach(cat => {
          if (!top5Set.has(cat.value)) {
            top5Set.add(cat.value);
            top5.push(cat);
          }
        });
      });
      const rest = this.allCategoriasSorted
        .filter(cat => !top5Set.has(cat))
        .map(cat => ({ label: this._catLabel(cat), value: cat }));
      return { top5, rest };
    },
  },
  async mounted() {
    const token = this.$route.params.token;
    const empresaQuery = this.$route.query && this.$route.query.empresa;
    if (empresaQuery) this.empresaId = parseInt(empresaQuery, 10) || null;
    await this.loadTaxonomias();
    this.loadCondiciones();
    this.loadUnidadesMedida();
    await this.fetchAll(token, true);
    await this.refreshKpis();
    window.addEventListener('scroll', this._onWindowScroll, { passive: true });
    this.$store.dispatch('setSidebarCollapsed', false);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this._onWindowScroll);
    this.$store.dispatch('setSidebarCollapsed', false);
  },

  // Salida de la vista por el router (menú, volver, otro módulo)
  async beforeRouteLeave(to, from, next) {
    if (await this.confirmarCambiosPendientes()) next();
    else next(false);
  },

  methods: {
    scrollTabla(direction) {
      const wrapper = this.$refs.tableWrapper;
      if (direction === 'top') {
        window.scrollTo({ top: wrapper.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
      } else if (direction === 'bottom') {
        window.scrollTo({ top: wrapper.getBoundingClientRect().bottom + window.scrollY, behavior: 'smooth' });
      } else {
        const amount = 300;
        wrapper.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
      }
    },

    _onWindowScroll() {
      const wrapper = this.$refs.tableWrapper;
      if (!wrapper) return;
      const thead = wrapper.querySelector('thead');
      if (!thead) return;
      const top = wrapper.getBoundingClientRect().top;
      if (top < 0) {
        thead.style.transform = `translateY(${-top}px)`;
        thead.style.zIndex = '100';
      } else {
        thead.style.transform = '';
        thead.style.zIndex = '';
      }
    },

    // Ini Ordenamiento de tabla ----------------------------
    ordenar(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
      this.buildSortedAll();
    },
    obtenerIconoOrden(columna) {
      if (this.ordenColumna !== columna) return '↕️';
      return this.ordenDireccion === 'asc' ? '↑' : '↓';
    },
    // Fin Ordenamiento de tabla ----------------------------

    async loadTaxonomias() {
      try {
        // Implementa este método en materialService (ver nota más abajo)
        const rows = await materialService.getTaxonomias();
        const map = Object.create(null);
        (rows || []).forEach(r => {
          // normaliza llaves
          const cat = String(r.Categoria || r.categoria || '').trim();
          if (!cat) return;
          map[cat] = {
            Clase:           String(r.Clase           || r.clase           || '').trim(),
            Segmento:        String(r.Segmento        || r.segmento        || '').trim(),
            Familia:         String(r.Familia         || r.familia         || '').trim(),
            CategoriaIngles: String(r.CategoriaIngles || r.categoriaIngles || '').trim(),
          };
        });
        this.taxByCategoria = map;
      } catch (e) {
        // Si falla, la UI sigue funcionando; solo no habrá autocompletado de clase/segmento/familia
        console.warn('[Taxonomias] no se pudo cargar:', e);
        this.taxByCategoria = Object.create(null);
      }
    },

    async loadCondiciones() {
      try {
        const data = await diccionarioService.getByTipo('CONDICION');
        this.condicionesOptions = Array.isArray(data)
          ? data.slice().sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'))
          : [];
      } catch (e) {
        console.warn('[Condiciones] no se pudo cargar:', e);
        this.condicionesOptions = [];
      }
    },

    async loadUnidadesMedida() {
      try {
        const data = await unidadMedidaService.getAll();
        this.unidadesMedidaOptions = Array.isArray(data)
          ? data.slice().sort((a, b) => (a.orden || 0) - (b.orden || 0) || (a.nombre || '').localeCompare(b.nombre || '', 'es'))
          : [];
      } catch (e) {
        console.warn('[UnidadesMedida] no se pudo cargar:', e);
        this.unidadesMedidaOptions = [];
      }
    },

    getUomLabel(item) {
      const opt = this.unidadesMedidaOptions.find(o => o.id === item.idUnidadDeMedida);
      if (!opt) return item.idUnidadDeMedida || '';
      return this.uomOptionLabel(opt);
    },

    uomOptionLabel(opt) {
      return (this.lang === 'en' ? opt.nombreEn : opt.nombre) || opt.codigo || '';
    },

    formatPrecio(precio) {
      if (precio === null || precio === undefined || precio === '') return '';
      const numero = Number(precio);
      if (Number.isNaN(numero)) return '';
      const locale = this.lang === 'en' ? 'en-US' : 'es-CL';
      return numero.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },

    getCategoryOptions(item) {
      const top5 = this.parseTop5Predicciones(item.top5Predicciones);
      const top5Values = new Set(top5.map(c => c.value));
      const rest = this.allCategoriasSorted
        .filter(cat => !top5Values.has(cat))
        .map(cat => ({ label: this._catLabel(cat), value: cat }));
      return { top5, rest };
    },

    _catLabel(cat) {
      if (this.lang !== 'en') return cat;
      const eng = this.taxByCategoria[cat] && this.taxByCategoria[cat].CategoriaIngles;
      return eng || cat;
    },

    resolveTaxonomia(categoria) {
      const key = String(categoria == null ? '' : categoria).trim();
      return this.taxByCategoria[key] || null;
    },

    applyTaxToItem(item, categoria) {
      const t = this.resolveTaxonomia(categoria);
      if (!t) return; // si no está en tabla, no tocamos nada
      // Refleja en UI (para que el usuario lo vea antes de guardar)
      item.clase = t.Clase;
      item.segmento = t.Segmento; // si no tienes columna visible, igual lo mandaremos en el payload
      item.familia = t.Familia;
    },
    isManualChoice(it) {
      // true = no colorear (usuario eligió algo distinto al top-1)
      const top1 = this.getTop1Category(it.top5Predicciones);
      return !!(it.manualOverride || !this.eqCat(it.categoriaInexlink, top1) || it.userModified);
    },
    async refreshKpis() {
      const token = this.$route.params.token;
      try {
        const raw = await materialService.getFileLog(token);

        // 🔎 DEBUGS: mira Network/Console para ver exactamente lo que llega
        console.log('RAW getFileLog (response):', raw);

        // Acepta diferentes envoltorios: array, {data}, objeto plano
        const payload = Array.isArray(raw)
          ? (raw[0] || {})
          : (raw && raw.data) ? raw.data
            : (raw || {});
        console.log('Archivo (normalizado):', payload);

        // Normaliza llaves y convierte a números
        let a = this.normalizeArchivo(payload);

        // KPI "Actualizadas manualmente": preferimos backend; si no viene, contamos vs Top-1
        if (Array.isArray(this.etlAll) && this.etlAll.length) {
          const backendVal = Number(a.actualizadasManualmente || 0);
          if (!backendVal) {
            a.actualizadasManualmente = this.etlAll.reduce((acc, it) => {
              const top1 = this.getTop1Category(it.top5Predicciones);
              return acc + (this.eqCat(it.categoriaInexlink, top1) ? 0 : 1);
            }, 0);
          } else {
            a.actualizadasManualmente = backendVal;
          }
        }

        // ✅ Fallback **visual**: si TODO viene 0/undefined y SÍ tenemos etlAll,
        // calcula conteos para no mostrar 0s. NO persiste, solo presentación.
        const totalKpis = (a.filasProcesadas || 0) + (a.itemsConsolidados || 0) +
          (a.actualizadasManualmente || 0) + (a.equipos || 0) +
          (a.componentes || 0) + (a.repuestos || 0) +
          (a.insumos || 0) + (a.mobiliarios || 0);

        const hasEtlData = Array.isArray(this.etlAll) && this.etlAll.length > 0;

        if (totalKpis === 0 && hasEtlData) {
          // Construye KPIs desde etlAll para mostrar algo consistente
          const t = this.etlAll;
          const countBy = (pred) => t.reduce((acc, it) => acc + (pred(it) ? 1 : 0), 0);

          const norm = s => String(s == null ? '' : s).trim().toUpperCase();

          a = {
            ...a,
            filasProcesadas: t.length,
            // Puedes adaptar estas reglas si tus categorías están en otro campo:
            equipos: countBy(it => norm(it.categoriaInexlink).includes('EQUIPO')),
            componentes: countBy(it => norm(it.categoriaInexlink).includes('COMPONENT')),
            repuestos: countBy(it => norm(it.categoriaInexlink).includes('REPUEST')),
            insumos: countBy(it => norm(it.categoriaInexlink).includes('INSUM')),
            mobiliarios: countBy(it => norm(it.categoriaInexlink).includes('MOBIL') || norm(it.categoriaInexlink).includes('MOBILI')),
            // Consolidado: si tienes manera de identificarlo en cada fila, cámbialo; si no, déjalo 0
            itemsConsolidados: a.itemsConsolidados || 0,
            // Actualizadas manualmente: si el backend aún no lo trae,
            // puedes aproximar con “filas donde categoriaInexlink != initialCategoriaInexlink”
            actualizadasManualmente: countBy(it => {
              const top1 = this.getTop1Category(it.top5Predicciones);
              return !this.eqCat(it.categoriaInexlink, top1);
            })
          };
          console.warn('[KPIs fallback desde etlAll] tallies:', a);
        }

        // Mantén nombreXLSX si el backend no lo envía pero ya lo teníamos
        if (!a.nombreXLSX) a.nombreXLSX = this.archivo && this.archivo.nombreXLSX ? this.archivo.nombreXLSX : '';

        this.archivo = a;
      } catch (e) {
        console.error('[refreshKpis] error:', e);
        // No tumbes la UI si falla
      }
    },

    normalizeArchivo(a) {
      // por si viene anidado en otras llaves
      if (a && typeof a === 'object') {
        a = a.archivo || a.result || a.meta || a;
      }

      const num = v => {
        if (v == null || v === '') return 0;
        const n = Number(typeof v === 'string' ? v.replace(',', '.') : v);
        return Number.isFinite(n) ? n : 0;
      };
      const pick = (obj, keys, def = 0) => {
        for (const k of keys) if (obj && obj[k] != null) return obj[k];
        return def;
      };
      const pickStr = (obj, keys, def = '') => {
        for (const k of keys) if (obj && obj[k] != null) return String(obj[k]);
        return def;
      };

      return {
        nombreXLSX: pickStr(a, ['nombreXLSX', 'NombreXLSX', 'nombreArchivo', 'NombreArchivo', 'fileName', 'FileName'], ''),
        filasProcesadas: num(pick(a, ['filasProcesadas', 'FilasProcesadas', 'lineasProcesadas', 'LineasProcesadas', 'Lineas', 'lineas'])),
        itemsConsolidados: num(pick(a, ['itemsConsolidados', 'ItemsConsolidados', 'lineasConsolidadas', 'LineasConsolidadas', 'Consolidadas'])),
        actualizadasManualmente: num(pick(a, ['actualizadasManualmente', 'ActualizadasManualmente', 'manualUpdates', 'ManualUpdates'])),
        equipos: num(pick(a, ['equipos', 'Equipos'])),
        componentes: num(pick(a, ['componentes', 'Componentes'])),
        repuestos: num(pick(a, ['repuestos', 'Repuestos'])),
        insumos: num(pick(a, ['insumos', 'Insumos'])),
        mobiliarios: num(pick(a, ['mobiliarios', 'Mobiliarios'])),
        estadoFlujo: pickStr(a, ['estadoFlujo', 'EstadoFlujo'], null),
        estadoFlujoDesc: pickStr(a, ['estadoFlujoDesc', 'EstadoFlujoDesc'], ''),
        estadoFlujoDescEn: pickStr(a, ['estadoFlujoDescEn', 'EstadoFlujoDescEn'], ''),
        // char(2) en la base: llega con espacios de relleno en algunos registros
        tipoFlujo: pickStr(a, ['tipoFlujo', 'TipoFlujo'], '').trim(),
      };
    },
    getIdNum(it) {
      const n = Number(it.idMaterialETL || it.idProducto || it.id);
      return isNaN(n) ? 0 : n;
    },
    getItemBucket(it) {
      if (this.isManualChoice(it)) return 3;           // “Manuales”
      return (typeof it._bucketFixed === 'number')
        ? it._bucketFixed
        : this.bucketByColor(this.getConfianzaValue(it.top5Predicciones, it.initialCategoriaInexlink));
    },

    applyFilters(baseArr) {
      let arr = baseArr;

      // 1) Filtro por color
      if (this.filterColor !== 'all') {
        const want = { green: 0, yellow: 1, red: 2, manual: 3 }[this.filterColor];
        arr = arr.filter(it => this.getItemBucket(it) === want);
      }

      // 2) Filtro por SKU-INEX
      if (this.searchId) {
        const q = String(this.searchId).trim().toLowerCase();
        arr = arr.filter(it => String(it.skuInexlink || '').toLowerCase().includes(q));
      }

      // 3) Filtro por Tipo Match
      if (this.searchTipoMatch) {
        const qtm = this.searchTipoMatch.trim().toLowerCase();
        arr = arr.filter(it => String(it.tipoMatch || '').toLowerCase().includes(qtm));
      }

      // 3a) Filtro por Brand Name
      if (this.searchBrandName) {
        const qbn = this.searchBrandName.trim().toLowerCase();
        arr = arr.filter(it => String(it.brandName || '').toLowerCase().includes(qbn));
      }

      // 3b) Filtro por Part Number
      if (this.searchPartNumber) {
        const qpn = String(this.searchPartNumber).trim().toLowerCase();
        arr = arr.filter(it => {
          const rawPn = (it.partNumber != null ? it.partNumber :
            (it.PartNumber != null ? it.PartNumber : ''));
          return String(rawPn).toLowerCase().includes(qpn);
        });
      }

      // 4) Filtro por Part Name
      if (this.searchPartName) {
        const q = this.searchPartName.toLowerCase();
        arr = arr.filter(it =>
          String(it.partNameSugerido || it.partNameOriginal || '').toLowerCase().includes(q)
        );
      }

      // 5) Filtro por Detalles
      if (this.searchDetalles) {
        const q = this.searchDetalles.toLowerCase();
        arr = arr.filter(it =>
          String(it.detallesSugerido || it.detallesOriginal || '').toLowerCase().includes(q)
        );
      }

      // 5.1) Filtro por Modelo
      if (this.searchModelo) {
        const q = this.searchModelo.trim().toLowerCase();
        arr = arr.filter(it => String(it.modelo || '').toLowerCase().includes(q));
      }

      // 6) Filtro por Categoría Origen
      if (this.searchCategoriaOrigen) {
        const q = this.searchCategoriaOrigen.toLowerCase();
        arr = arr.filter(it => String(it.categoriaOrigen || '').toLowerCase().includes(q));
      }

      // 7) Filtro por Categoría Inexlink
      if (this.searchCategoriaInexlink) {
        const q = this.searchCategoriaInexlink.toLowerCase();
        arr = arr.filter(it => String(it.categoriaInexlink || '').toLowerCase().includes(q));
      }

      // 8) Filtro por Clase
      if (this.searchClase) {
        const q = this.searchClase.toLowerCase();
        arr = arr.filter(it => String(it.clase || '').toLowerCase().includes(q));
      }

      // 8.1) Filtro por Precio (Valor Libro USD)
      if (this.searchPrecio) {
        const q = this.searchPrecio.toLowerCase();
        arr = arr.filter(it => this.formatPrecio(it.precio).toLowerCase().includes(q));
      }

      // 9) Filtro por Condición de Uso
      if (this.searchCondicion) {
        const q = this.searchCondicion.toLowerCase();
        arr = arr.filter(it => this.getCondicionLabel(it).toLowerCase().includes(q));
      }

      // 10) Filtro por UOM
      if (this.searchUom) {
        const q = this.searchUom.toLowerCase();
        arr = arr.filter(it => this.getUomLabel(it).toLowerCase().includes(q));
      }

      return arr;
    },

    getCondicionLabel(item) {
      const condicion = this.condicionesOptions.find(c => Number(c.id) === item.idCondicion);
      if (!condicion) return '';
      return (this.lang === 'en' ? condicion.nombreIngles : condicion.nombre) || '';
    },

    onFiltersChange() {
      this.currentPage = 1;   // si cambian filtros, vuelve a la primera página
      this.buildSortedAll();
    },
    normCat(s) {
      return String(s == null ? '' : s).trim().toUpperCase();
    },
    eqCat(a, b) {
      return this.normCat(a) === this.normCat(b);
    },
    async fetchAll(token = this.$route.params.token, skipPrompt = false, showOverlay = true) {
      const unsavedChanges = this.getModifiedRows().length > 0;

      // 1) Prompt por cambios sin guardar (antes del overlay)
      if (unsavedChanges && !skipPrompt) {
        const answer = await Swal.fire({
          title: this.$t('cambios_sin_guardar'),
          text: this.$t('desea_guardar_cambios'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('si_guardar'),
          cancelButtonText: this.$t('no_continuar'),
        });
        if (answer.isConfirmed) {
          try {
            const rows = this.getModifiedRows();
            if (rows.length) {
              // congelar orden visible
              this.freezeOrder = true;
              this.orderLock = this.etl.map(it => it.idMaterialETL);
              await materialService.updateMaterialETL(token, rows);
              Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), "success");
            }
          } catch (e) {
            Swal.fire("Error", this.$t('no_se_pudo_guardar'), "error");
            return;
          }
        }
      }

      // 2) Mostrar overlay después de responder el prompt
      if (showOverlay) {
        this.isPageLoading = true;
        this.loadingMessage = (this.$t && this.$t('cargando')) ? (this.$t('cargando') + '...') : 'Cargando...';
      }

      try {
        const BULK_PAGE_SZ = 500;

        // Mapper de ítems (mismo que ya tenías)
        const mapItem = (item) => {
          item.idMaterialETL = item.idMaterialETL != null ? item.idMaterialETL : item.IdMaterialETL;

          const top1 = this.getTop1Category(item.top5Predicciones);

          // "inicial" es lo que verá/editará el usuario (si no hay valor, cae al Top-1)
          let inicial = item.categoriaInexlink;
          if (!inicial && top1) inicial = top1;

          // 🔒 ORDEN FIJO: SIEMPRE por la confianza del Top-1 (o del máximo de predicciones)
          const confFixed = this.getConfianzaValue(item.top5Predicciones, top1); // 0–100
          const bucketFixed = this.bucketByColor(confFixed); // 0=verde,1=amarillo,2=rojo

          // Confianza "actual" para pintar si NO es manual (solo UI)
          const confNow = this.getConfianzaValue(item.top5Predicciones, inicial);

          const mapped = {
            ...item,
            skuInexlink: item.skuInexlink != null ? String(item.skuInexlink).replace(/\./g, '') : item.skuInexlink,
            categoriaInexlink: inicial,
            initialCategoriaInexlink: inicial,

            // FLAGS de edición
            showGuardar: false,
            manualOverride: false,
            userModified: false,

            // Para UI (color si coincide con Top-1; si es manual, se descolorea por isManualChoice)
            confianza: confNow,

            // normalizar nombres PascalCase para que coincidan con el template
            ActPartNameBNPN: !!(item.ActPartNameBNPN !== undefined ? item.ActPartNameBNPN : item.actPartNameBNPN),
            ActDetallesBNPN:  !!(item.ActDetallesBNPN  !== undefined ? item.ActDetallesBNPN  : item.ActDetallesBNPN),
            ActBrandNameBNPN: !!(item.ActBrandNameBNPN !== undefined ? item.ActBrandNameBNPN : item.actBrandNameBNPN),

            // 🔒 FIJOS para mantener orden global estable aunque se edite/guarde en cualquier página
            _confFixed: confFixed,
            _bucketFixed: bucketFixed,
          };

          // Referencia para detectar cambios sin guardar (celdas en amarillo)
          mapped._orig = this.snapshotEditable(mapped);
          return mapped;
        };

        // 4) Prefetch TOTAL por lotes con progreso en el overlay
        const all = [];
        const firstBulk = await this.fetchEtlBloque(token, 1, BULK_PAGE_SZ, true);
        const totalCount = Number(firstBulk.totalCount || 0);
        const totalPages = Math.ceil(totalCount / BULK_PAGE_SZ);
        all.push.apply(all, firstBulk.items.map(mapItem));

        if (showOverlay) {
          var lbl = (this.$t && this.$t('cargando')) ? this.$t('cargando') : 'Cargando';
          this.loadingMessage = lbl + ' ' + totalCount + ' items, por favor espere...';
        }

        // progreso inicial
        let loaded = Array.isArray(firstBulk.items) ? firstBulk.items.length : 0;
        if (showOverlay) {
          var lbl2 = (this.$t && this.$t('cargando')) ? this.$t('cargando') : 'Cargando';
          this.loadingMessage = lbl2 + ' ' + loaded + ' / ' + totalCount + ' items...';
        }

        const pages = [];
        for (let p = 2; p <= totalPages; p++) pages.push(p);

        // 3 y no 6: con seis consultas simultáneas sobre la misma tabla el backend
        // supera su timeout de 30 s y devuelve 500 en la mitad de los bloques.
        // Menos paralelismo termina siendo más rápido porque no se pisan entre sí.
        const CONCURRENCY = 3;
        for (let i = 0; i < pages.length; i += CONCURRENCY) {
          const slice = pages.slice(i, i + CONCURRENCY);
          // Promise.all y no allSettled: si un bloque no se puede recuperar hay que
          // abortar la carga. Seguir adelante dejaba la tabla incompleta sin aviso.
          const results = await Promise.all(
            slice.map(p => this.fetchEtlBloque(token, p, BULK_PAGE_SZ, false))
          );
          results.forEach(r => {
            all.push.apply(all, r.items.map(mapItem));
            loaded += r.items.length;
          });

          // Actualiza el texto de progreso cada bloque
          if (showOverlay) {
            var lbl3 = (this.$t && this.$t('cargando')) ? this.$t('cargando') : 'Cargando';
            this.loadingMessage = lbl3 + ' ' + loaded + ' / ' + totalCount + ' items...';
          }
        }

        // 5) Guardar, recalcular y paginar
        this.etlAll = all;
        this.totalCount = totalCount;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);

        // 👉 Si está congelado (venimos de guardar), construye una vez con "freeze" para NO reordenar la vista actual.
        //    Luego, al "descongelar" en el finally, haremos un segundo build global SIN freeze.
        if (this.freezeOrder) {
          this.buildSortedAll(); // mantiene la vista actual amigable
        } else {
          this.buildSortedAll(); // caso normal
        }

      } catch (e) {
        // Un bloque perdido significa filas faltantes. Preferimos no mostrar la
        // tabla antes que mostrarla incompleta: guardar o exportar sobre datos
        // parciales es peor que no cargar.
        const msg = String((e && e.message) || e);
        Swal.fire(
          "Error",
          msg.indexOf(BLOQUE_ETL_FALLIDO) === 0
            ? this.$t('error_carga_parcial')
            : this.$t('no_se_pudo_cargar'),
          "error"
        );
      } finally {
        // snapshot por si lo necesitas para métricas/log (no lo re-inyectaremos)
        const keepPageNum = this.currentPage;

        const wasFrozen = this.freezeOrder;
        this.freezeOrder = false;
        this.orderLock = [];

        if (showOverlay) {
          this.isPageLoading = false;
          this.loadingMessage = '';
        }

        // ✅ Tras descongelar: reconstruir orden GLOBAL y mostrar la página actual ya ordenada
        if (wasFrozen) {
          this.buildSortedAll();          // recalcula (color fijo → % fija → ID)
          this.currentPage = keepPageNum; // conserva el número de página
          this.pageSlice(true);           // ← pintar la página desde sortedAll (NO usar keepPage)
        }
      }
    },

    /**
     * Trae un bloque del ETL, reintentando ante fallos transitorios.
     *
     * materialService.getResultETL captura los errores HTTP y devuelve [], así que
     * un 500 del backend llega aquí como un valor sin `items`. Antes ese caso se
     * descartaba en silencio y la tabla quedaba incompleta sin ningún aviso: con
     * 7.300 filas se perdían ~3.000 y la pantalla las mostraba como si estuvieran
     * todas. Ahora se reintenta y, si no hay caso, se lanza para abortar la carga.
     */
    async fetchEtlBloque(token, page, pageSize, includeTotal, intentos = 3) {
      for (let intento = 1; intento <= intentos; intento++) {
        const resp = await materialService.getResultETL(token, page, pageSize, this.lang, includeTotal);
        if (resp && Array.isArray(resp.items)) return resp;

        if (intento < intentos) {
          // Espera creciente: el backend falla por timeout bajo carga, así que
          // reintentar de inmediato solo agrava la contención.
          await new Promise(resolve => setTimeout(resolve, 1500 * intento));
        }
      }
      throw new Error(BLOQUE_ETL_FALLIDO + page);
    },

    buildSortedAll() {
      // 1) Metadatos y orden base congelado (_orderLock)
      this.etlAll.forEach((it, idx) => {
        if (typeof it._orderLock !== 'number') it._orderLock = this.getIdNum(it);

        // Confianza actual (sólo para UI/tooltip, NO para el bucket de orden)
        const confNow = Number(
          isFinite(it.confianza)
            ? it.confianza
            : this.getConfianzaValue(it.top5Predicciones, it.categoriaInexlink)
        );

        it._idx = idx;
        it._conf = confNow;

        // 🔒 Bucket y confianza FIJOS para ORDEN global
        if (typeof it._bucketFixed !== 'number') {
          const confInit = this.getConfianzaValue(it.top5Predicciones, it.initialCategoriaInexlink);
          it._bucketFixed = this.bucketByColor(confInit);
          it._confFixed = confInit;
        }

        // Este es el bucket que se usará SIEMPRE para ordenar
        it._bucket = it._bucketFixed;
      });

      // 2) Partimos del arreglo en REFERENCIAS
      let arr = this.etlAll.slice();

      // 3) ¿Hay freeze por guardado? → respeta orden visible exacto
      if (this.freezeOrder && this.orderLock && this.orderLock.length) {
        const pos = new Map();
        this.orderLock.forEach((id, i) => pos.set(id, i));
        arr.sort((a, b) => {
          const ai = pos.has(a.idMaterialETL) ? pos.get(a.idMaterialETL) : Number.MAX_SAFE_INTEGER;
          const bi = pos.has(b.idMaterialETL) ? pos.get(b.idMaterialETL) : Number.MAX_SAFE_INTEGER;
          if (ai !== bi) return ai - bi;
          return a._orderLock - b._orderLock; // mantiene orden base
        });
      } else if (this.sortMode === 'confidence') {
        // Orden de color: rojo(2) → amarillo(1) → verde(0) → manual(3)
        const colorRank = (bucket) => {
          if (bucket === 2) return 0;
          if (bucket === 1) return 1;
          if (bucket === 0) return 2;
          return 3; // manual
        };

        // color (bucket FIJO) → % FIJO desc → ID asc
        arr.sort((a, b) => {
          const ra = colorRank(a._bucket);
          const rb = colorRank(b._bucket);
          if (ra !== rb) return ra - rb;
          if (a._bucket !== 3) {
            const byConf = (b._confFixed || 0) - (a._confFixed || 0); // ← usa confianza FIJA
            if (byConf !== 0) return byConf;
          }
          return a._orderLock - b._orderLock;
        });
      } else {
        // Fijo (no reordenar) = ID asc
        arr.sort((a, b) => a._orderLock - b._orderLock);
      }

      // 5) Aplica filtros de color y pagina
      this.sortedAll = this.applyFilters(arr);

      // 6) Ordenamiento por columna (si está activo)
      if (this.ordenColumna) {
        this.sortedAll = [...this.sortedAll].sort((a, b) => {
          let valorA = this.ordenColumna === 'condicion' ? this.getCondicionLabel(a) : a[this.ordenColumna];
          let valorB = this.ordenColumna === 'condicion' ? this.getCondicionLabel(b) : b[this.ordenColumna];
          if (valorA === null || valorA === undefined) valorA = '';
          if (valorB === null || valorB === undefined) valorB = '';
          if (typeof valorA === 'number' && typeof valorB === 'number') {
            return this.ordenDireccion === 'asc' ? valorA - valorB : valorB - valorA;
          }
          valorA = String(valorA).toLowerCase();
          valorB = String(valorB).toLowerCase();
          if (valorA < valorB) return this.ordenDireccion === 'asc' ? -1 : 1;
          if (valorA > valorB) return this.ordenDireccion === 'asc' ? 1 : -1;
          return 0;
        });
      }

      // La paginacion se calcula sobre lo filtrado, no sobre el archivo completo:
      // si no, al filtrar quedaban paginas vacias navegables.
      this.totalFiltrado = this.sortedAll.length;
      this.totalPages = Math.max(1, Math.ceil(this.totalFiltrado / this.pageSize));

      if (this.currentPage > this.totalPages) this.currentPage = 1;
      this.pageSlice(true); // baseline nuevo tras reload
    },

    getTop1Category(top5Predicciones) {
      try {
        const preds = JSON.parse(String(top5Predicciones).replace(/'/g, '"'));
        let bestKey = null, bestVal = -Infinity;
        for (const [k, v] of Object.entries(preds)) {
          const n = Number(v);
          if (n > bestVal) { bestVal = n; bestKey = k; }
        }
        return bestKey || null;
      } catch { return null; }
    },

    getConfianzaValue(top5Predicciones, categoriaActual) {
      try {
        const raw = JSON.parse(String(top5Predicciones).replace(/'/g, '"'));
        // normalizar claves -> diccionario
        const preds = {};
        Object.entries(raw).forEach(([k, v]) => { preds[this.normCat(k)] = Number(v); });

        const keys = Object.keys(preds);
        if (!keys.length) return 0;

        const key = this.normCat(categoriaActual);
        const val = (key && preds[key] != null)
          ? preds[key]
          : Math.max(...keys.map(k => preds[k]));

        return isFinite(val) ? (val * 100) : 0; // 0–100
      } catch {
        return 0;
      }
    },

    bucketByColor(conf) {
      // 0 = verde, 1 = amarillo, 2 = rojo
      // Redondear a 1 decimal para que 79.995 → 80.0 sea verde (igual que el display)
      const c = Math.round(conf * 10) / 10;
      if (c >= 80) return 0;
      if (c >= 41) return 1;
      return 2;
    },
    onChangePageSize() {
      this.totalPages = Math.max(1, Math.ceil(this.totalFiltrado / this.pageSize));
      this.setPage(1);
    },
    async setPage(page) {
      // Avisa antes de cambiar de página si quedan filas en amarillo
      if (!(await this.confirmarCambiosPendientes())) return;
      this.currentPage = page;
      this.pageSlice(true); // ← ahora sí resetea initialEtl para la nueva página
    },
    pageSlice(resetInitial = false) {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      // Importante: usar slice de objetos existentes (referencias), NO clonar.
      this.etl = this.sortedAll.slice(start, end);
      // Solo cuando cambiamos de página/tamaño o recargamos todo
      if (resetInitial) {
        this.initialEtl = JSON.parse(JSON.stringify(this.etl));
      }
    },
    calcularColorPorConfianza(confianzaRaw) {
      const raw = confianzaRaw ? parseFloat(confianzaRaw.toString().replace(',', '.')) : 0;
      const confianza = Math.round(raw * 10) / 10;

      if (confianza >= 80) return { backgroundColor: '#a1ebb2', color: '#ffffff' };
      if (confianza >= 41) return { backgroundColor: '#ffedb6', color: '#212529' };
      return { backgroundColor: '#ff9fa8', color: '#ffffff' };
    },

    parseTop5Predicciones(top5Predicciones) {
      try {
        //const parsed = JSON.parse(top5Predicciones.replace(/'/g, '"'));
        const parsed = JSON.parse(String(top5Predicciones || '{}').replace(/'/g, '"'));
        return Object.entries(parsed).map(([key, value]) => ({
          label: `${this._catLabel(key)} (${(parseFloat(value) * 100).toFixed(1)}%)`,
          value: key,
          fullLabel: key,
          confidence: (parseFloat(value) * 100).toFixed(1)
        }));
      } catch {
        return [];
      }
    },

    getPrediccionTexto(item) {
      try {
        const raw = JSON.parse(item.top5Predicciones.replace(/'/g, '"'));
        const preds = {};
        Object.entries(raw).forEach(([k, v]) => { preds[this.normCat(k)] = Number(v); });
        const p = preds[this.normCat(item.categoriaInexlink)];
        return (p != null)
          ? `${this.$t('prediccion')} "${this._catLabel(item.categoriaInexlink)}": ${(p * 100).toFixed(1)}%`
          : this.$t('sin_prediccion');
      } catch {
        return this.$t('sin_prediccion');
      }
    },

    async fetchPage(page, token = this.$route.params.token, skipPrompt = false) {
      const unsavedChanges = this.getModifiedRows().length > 0;
      if (unsavedChanges && !skipPrompt) {
        const answer = await Swal.fire({
          title: this.$t('cambios_sin_guardar'),
          text: this.$t('desea_guardar_cambios'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('si_guardar'),
          cancelButtonText: this.$t('no_continuar'),
        });
        if (answer.isConfirmed) {
          try {
            const rows = this.getModifiedRows();
            if (rows.length) {
              await materialService.updateMaterialETL(token, rows);
              Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), "success");
              // Reset flags
              this.etl.forEach(i => {
                i.showGuardar = false;
                this.resetSnapshotEditable(i);
              });
              this.initialEtl = JSON.parse(JSON.stringify(this.etl));
            }
          } catch {
            Swal.fire("Error", this.$t('no_se_pudo_guardar'), "error");
            return;
          }
        }
      }

      const prev = this.currentPage;
      try {
        const resp = await materialService.getResultETL(token, page, this.pageSize, this.lang);
        this.etl = resp.items.map(item => {
          const cats = this.parseTop5Predicciones(item.top5Predicciones);
          let inicial = item.categoriaInexlink;
          let isPred = false;
          if (!inicial && cats.length) {
            inicial = cats[0].value;
            isPred = true;
          }
          const mapped = {
            ...item,
            categoriaInexlink: inicial,
            initialCategoriaInexlink: inicial,
            showGuardar: false,
            manualOverride: !isPred && !!item.categoriaInexlink,
            userModified: false,
            // normalizar nombres PascalCase para que coincidan con el template
            ActPartNameBNPN: !!(item.ActPartNameBNPN !== undefined ? item.ActPartNameBNPN : item.actPartNameBNPN),
            ActDetallesBNPN:  !!(item.ActDetallesBNPN  !== undefined ? item.ActDetallesBNPN  : item.ActDetallesBNPN),
            ActBrandNameBNPN: !!(item.ActBrandNameBNPN !== undefined ? item.ActBrandNameBNPN : item.actBrandNameBNPN),
          };

          // Referencia para detectar cambios sin guardar (celdas en amarillo)
          mapped._orig = this.snapshotEditable(mapped);
          return mapped;
        });
        this.initialEtl = JSON.parse(JSON.stringify(this.etl));
        this.currentPage = page;
        this.totalPages = Math.ceil(resp.totalCount / this.pageSize);
        this.totalCount = resp.totalCount;
      } catch {
        this.currentPage = prev;
        Swal.fire("Error", this.$t('no_se_pudo_cargar'), "error");
      }
    },

    onCategoriaChange(item) {
      item.showGuardar = true;
      item.userModified = true;
      item.confianza = this.getConfianzaValue(item.top5Predicciones, item.categoriaInexlink);

      // 🔁 espejo en la UI: MM = Inexlink
      // item.categoria_MM = item.categoriaInexlink;

      // 🔁 sincroniza Clase/Segmento/Familia desde Taxonomias
      this.applyTaxToItem(item, item.categoriaInexlink);

      const top1 = this.getTop1Category(item.top5Predicciones);
      item.manualOverride = (item.categoriaInexlink !== item.initialCategoriaInexlink);
      this.pageSlice(false);
    },

    getModifiedRows() {
      // helpers
      const toNullIfEmpty = function (v) {
        if (v === undefined || v === null) return null;
        const s = String(v).trim();
        return s === '' ? null : v;
      };
      const numOrNull = function (v) {
        if (v === undefined || v === null || v === '') return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      // detecta filas con cambios visibles usando el flag showGuardar,
      // que es seteado por todos los @input handlers y no se corrompe
      // al reordenar/filtrar (a diferencia de la comparación por índice con initialEtl,
      // que falla porque etl/sortedAll/etlAll comparten referencias y buildSortedAll
      // sobreescribe initialEtl con los valores ya modificados)
      // Se recorren TODAS las filas cargadas, no solo la página visible: etl es un slice
      // por referencia de etlAll, así que lo editado en otra página sigue vivo y debe viajar.
      const fuente = (this.etlAll && this.etlAll.length) ? this.etlAll : this.etl;
      const changed = fuente.filter(item => !!item.showGuardar);

      // ⚠️ HOTFIX: payload mínimo, tipos correctos, y las 3 columnas sensibles
      return changed.map(item => {
        // espejo único para ambas columnas
        const cat = toNullIfEmpty(item.categoriaInexlink);

        return {
          IdMaterialETL: item.idMaterialETL,
          Token: this.$route.params.token,

          // campos de la tabla (strings como string, números como número o null)
          IdProducto: toNullIfEmpty(item.idProducto),
          BrandName: toNullIfEmpty(item.brandName),
          PartNumber: toNullIfEmpty(item.partNumber),
          //PartName: toNullIfEmpty(item.partName),
          Modelo: toNullIfEmpty(item.modelo !== undefined ? item.modelo : item.Modelo),
          Referencia: toNullIfEmpty(item.referencia !== undefined ? item.referencia : item.Referencia),
          CategoriaOrigen: toNullIfEmpty(item.categoriaOrigen),
          Detalles: toNullIfEmpty(item.detalles),
          Cantidad: numOrNull(item.cantidad),
          //Categoria_MM:        cat,                 // ← espejo con Inexlink
          Clase: toNullIfEmpty(item.clase),
          Segmento: toNullIfEmpty(item.segmento !== undefined ? item.segmento : item.Segmento),
          Familia: toNullIfEmpty(item.familia !== undefined ? item.familia : item.Familia),
          IdCondicion: numOrNull(item.idCondicion),
          IdUnidadDeMedida: numOrNull(item.idUnidadDeMedida),
          TasaRetornoEsperada: numOrNull(item.tasaRetornoEsperada),
          CategoriaInexlink: cat,
          ActPartNameBNPN: !!item.ActPartNameBNPN,
          ActDetallesBNPN: !!item.ActDetallesBNPN,
          PartNameSugerido: item.partNameSugerido || null,
          DetallesSugerido: item.detallesSugerido || null,

          // 🛡️ columnas sensibles (para que NO se borren al actualizar)
          Horometro: toNullIfEmpty(item.horometro !== undefined ? item.horometro : item.Horometro),
          AnoFabricacion: numOrNull(item.anoFabricacion !== undefined ? item.anoFabricacion : item.AnoFabricacion),
          Kilometros: toNullIfEmpty(item.kilometros !== undefined ? item.kilometros : item.Kilometros),
        };
      });
    },

    async confirmGuardar() {
      if (!this.puedeEditarArchivo) return;
      // 0) Validar filas modificadas: UOM y Condición son obligatorias
      const rows = this.getModifiedRows();
      if (!rows.length) {
        Swal.fire(this.$t('informacion'), this.$t('no_hay_cambios'), "info");
        return;
      }

      const filasSinUomOCondicion = rows.some(r => r.IdUnidadDeMedida == null || r.IdCondicion == null);
      if (filasSinUomOCondicion) {
        Swal.fire({ icon: 'warning', title: this.$t('datos_incompletos'), text: this.$t('debe_seleccionar_uom_condicion') });
        return;
      }

      const confirm = await Swal.fire({
        title: this.$t('guardar_cambios_pregunta'),
        text: this.$t('se_guardaran_cambios'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t('si_guardar'),
        cancelButtonText: this.$t('cancelar'),
      });
      if (!confirm.isConfirmed) return;

      const token = this.$route.params.token;

      // 2) Flags de guardado y "freeze" del orden visible
      this.isSaving = true;
      this.freezeOrder = true;
      this.orderLock = this.etl.map(it => it.idMaterialETL);

      let savedOk = false;

      try {
        // 3) Guardar en backend (ÚNICO try/catch para "guardar")
        await materialService.updateMaterialETL(token, rows);
        savedOk = true;

        // 3.1 Éxito de guardado
        await Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), "success");
      } catch (err) {
        console.error('[updateMaterialETL] error:', err);
        Swal.fire("Error", this.$t('no_se_pudo_guardar_cambios'), "error");
      } finally {
        // desmontaje parcial de flags (el orden lo terminamos de recomponer tras el refresh)
        this.isSaving = false;
      }

      if (!savedOk) {
        // si falló el guardado, salimos aquí
        return;
      }

      // 4) Intentar refrescar datos SIN romper la UX si falla
      try {
        // Re-cargar datos; no queremos overlay acá para que no se sienta pesado
        await this.fetchAll(token, true, false);
        await this.refreshKpis();
      } catch (err) {
        console.warn('[fetch after save] Guardó pero falló el refresh:', err);

        // fallback local: mantén orden y vista estable aunque no se haya podido recargar
        this.buildSortedAll();
        this.pageSlice(true);
        // opcional: aviso suave
        // Swal.fire(this.$t('informacion'), this.$t('no_se_pudo_actualizar_vista'), 'info');
      } finally {
        // 5) Reacomodo final del orden y flags tras el ciclo de guardado
        const keepPageNum = this.currentPage;

        const wasFrozen = this.freezeOrder;
        this.freezeOrder = false;
        this.orderLock = [];

        if (wasFrozen) {
          this.buildSortedAll();          // orden global correcto
          this.currentPage = keepPageNum; // mantener página
          this.pageSlice(true);           // pintar desde sortedAll
        }

        // Reset de flags visibles de edición
        this.etl.forEach(item => {
          item.showGuardar = false;
          item.userModified = false;
          item.manualOverride = false;
          item.initialCategoriaInexlink = item.categoriaInexlink;
          this.resetSnapshotEditable(item);
        });
        this.initialEtl = JSON.parse(JSON.stringify(this.etl));
      }
    },

    async exportFile() {
      const ok = await Swal.fire({
        title: this.$t('exportar_archivo_pregunta'),
        text: this.$t('se_descargara_excel'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t('se_descargara_excel'),
        cancelButtonText: this.$t('cancelar'),
      });
      if (!ok.isConfirmed) return;

      try {
        const headers = [
          'idMaterialETL',
          'SKU-INEX',
          `${this.$t('nombre_corto')} (${this.$t('sugerido')})`,
          `${this.$t('nombre_corto')} (${this.$t('original')})`,
          'TipoMatch',
          this.$t('usar_original') + ' ' + this.$t('nombre_corto'),
          `${this.$t('nombre_largo')} (${this.$t('sugerido')})`,
          `${this.$t('nombre_largo')} (${this.$t('original')})`,
          this.$t('usar_original') + ' ' + this.$t('nombre_largo'),
          this.$t('brand_name'),
          this.$t('part_number'),
          this.$t('modelo'),
          this.$t('categoria_origen'),
          this.$t('categoria_inexlink'),
          this.$t('cluster_clase'),
          this.$t('precio') || 'Valor Libro (USD)',
          this.$t('cantidad'),
          this.$t('uom'),
          this.$t('condicion'),
        ];

        const data = (this.etlAll.length ? this.etlAll : this.etl).map(item => {
          const condicion = this.condicionesOptions.find(c => Number(c.id) === item.idCondicion);
          const condicionLabel = condicion
            ? (this.lang === 'en' ? condicion.nombreIngles : condicion.nombre)
            : (item.condicion || '');
          return [
            item.idMaterialETL,
            item.skuInexlink,
            item.partNameSugerido,
            item.partNameOriginal,
            item.tipoMatch,
            !item.ActPartNameBNPN ? this.$t('original') : this.$t('sugerido'),
            item.detallesSugerido,
            item.detallesOriginal,
            !item.ActDetallesBNPN ? this.$t('original') : this.$t('sugerido'),
            item.brandName,
            item.partNumber,
            item.modelo,
            item.categoriaOrigen,
            item.categoriaInexlink,
            item.clase,
            this.formatPrecio(item.precio),
            item.cantidad,
            this.getUomLabel(item),
            condicionLabel,
          ];
        });

        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Materiales');
        const fecha = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(wb, `materiales_${fecha}.xlsx`);
      } catch {
        Swal.fire("Error", this.$t('no_se_pudo_exportar'), "error");
      }
    },

    async refreshTable() {
      await this.fetchAll(this.$route.params.token);
      await this.refreshKpis();
      this.etl.forEach(item => item.showGuardar = false);
    },

    // ===== Marcado de cambios pendientes de guardar =====
    // Foto de los campos editables tal como están en la base de datos.
    snapshotEditable(item) {
      const snap = {};
      CAMPOS_EDITABLES.forEach(campo => { snap[campo] = valorComparable(item[campo]); });
      return snap;
    },

    // true si el campo difiere de lo guardado: la celda se pinta en amarillo.
    campoModificado(item, campo) {
      if (!item || !item._orig) return false;
      return item._orig[campo] !== valorComparable(item[campo]);
    },

    // Para celdas que agrupan más de un control (nombre corto / nombre largo).
    algunCampoModificado(item, campos) {
      return campos.some(campo => this.campoModificado(item, campo));
    },

    // La fila lleva una marca lateral mientras tenga cambios sin guardar. Se mira también
    // showGuardar porque es el flag que decide qué filas se envían al backend: si está
    // marcada para guardar, el usuario debe verlo aunque el valor haya vuelto al original.
    filaModificada(item) {
      if (!item) return false;
      if (item.showGuardar) return true;
      return CAMPOS_EDITABLES.some(campo => this.campoModificado(item, campo));
    },

    // Tras guardar, lo editado pasa a ser el nuevo valor de referencia.
    resetSnapshotEditable(item) {
      this.$set(item, '_orig', this.snapshotEditable(item));
    },

    // Diálogo común a los puntos donde el usuario deja atrás lo que está editando
    // (cambio de página de la tabla o salida de la vista). Solo informa: para conservar
    // los cambios hay que cancelar y usar el botón GUARDAR CAMBIOS.
    // Devuelve false para quedarse donde está.
    async confirmarCambiosPendientes() {
      if (!this.hayCambiosSinGuardar) return true;

      const answer = await Swal.fire({
        title: this.$t('cambios_sin_guardar'),
        text: this.$t('cambios_se_perderan'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('salir_perder_cambios'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#d33',
      });

      return answer.isConfirmed; // cancelar o cerrar = quedarse
    },

    toggleAllChecks(event) {
      if (event.target.checked) {
        this.checkedIds = this.etl.map(item => item.idMaterialETL);
      } else {
        this.checkedIds = [];
      }
    },

    toggleAllChecksCondicion(event) {
      if (event.target.checked) {
        this.checkedIdsCondicion = this.etl.map(item => item.idMaterialETL);
      } else {
        this.checkedIdsCondicion = [];
      }
    },

    toggleAllChecksUom(event) {
      if (event.target.checked) {
        this.checkedIdsUom = this.etl.map(item => item.idMaterialETL);
      } else {
        this.checkedIdsUom = [];
      }
    },

    toggleAllChecksBrandName(event) {
      if (event.target.checked) {
        this.checkedIdsBrandName = this.etl.map(item => item.idMaterialETL);
      } else {
        this.checkedIdsBrandName = [];
      }
    },

    // ===== Importación masiva de categorías desde Excel =====
    abrirImportCategorias() {
      if (!this.puedeEditarArchivo) return;
      this.importPreview = null;
      this.importError = null;
      this.isImportParsing = false;
      if (this.$refs.importCategoriasInput) this.$refs.importCategoriasInput.value = '';
      this.showImportCategoriasModal = true;
    },

    // Busca la columna cuyo encabezado sea exactamente el nombre pedido.
    // Sólo se ignoran mayúsculas, acentos y separadores, de modo que
    // "Categoría Inexlink" y "CATEGORIA_INEXLINK" valen, pero NO se aceptan
    // nombres distintos (p. ej. "Categoria", que podría ser Categoría Origen).
    _pickCol(headers, nombreExacto) {
      const norm = s => String(s == null ? '' : s)
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[\s_-]+/g, '')
        .toLowerCase().trim();
      const wanted = norm(nombreExacto);
      for (const h of headers) {
        if (norm(h) === wanted) return h;
      }
      return null;
    },

    async onImportCategoriasFile(evt) {
      if (!this.puedeEditarArchivo) return;
      const file = evt && evt.target && evt.target.files && evt.target.files[0];
      this.importPreview = null;
      this.importError = null;
      if (!file) return;

      this.isImportParsing = true;
      try {
        const buf = await file.arrayBuffer();
        const wb = XLSX.read(buf, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        if (!ws) throw new Error(this.$t('import_error_hoja'));

        const rows = XLSX.utils.sheet_to_json(ws, { defval: null });
        if (!rows.length) throw new Error(this.$t('import_error_vacio'));

        const headers = Object.keys(rows[0]);
        const colId = this._pickCol(headers, 'IdMaterialETL');
        const colCat = this._pickCol(headers, 'CategoriaInexlink');

        // Sin ambas columnas no se procesa nada: se informa cuál falta.
        if (!colId || !colCat) {
          const faltantes = [];
          if (!colId) faltantes.push('IdMaterialETL');
          if (!colCat) faltantes.push('CategoriaInexlink');
          throw new Error(
            this.$t('import_error_columnas', { columnas: faltantes.join(', ') })
            + ' ' + this.$t('import_error_columnas_encontradas', { headers: headers.join(', ') })
          );
        }

        // Ids que realmente pertenecen a este archivo (validación previa; el backend la repite)
        const idsArchivo = new Set(
          (this.etlAll.length ? this.etlAll : this.etl).map(it => Number(it.idMaterialETL))
        );

        const vistos = new Set();
        const invalidas = new Set();
        const filas = [];
        let incompletas = 0, sinMatch = 0, categoriaInvalida = 0, duplicados = 0;

        rows.forEach(r => {
          const id = Number(r[colId]);
          const cat = r[colCat] == null ? '' : String(r[colCat]).trim();

          if (!Number.isFinite(id) || id <= 0 || !cat) { incompletas++; return; }
          if (!idsArchivo.has(id)) { sinMatch++; return; }
          if (!this.resolveTaxonomia(cat)) { categoriaInvalida++; invalidas.add(cat); return; }
          if (vistos.has(id)) { duplicados++; }

          vistos.add(id);
          filas.push({ IdMaterialETL: id, CategoriaInexlink: cat });
        });

        // Si un id viene repetido, gana la última aparición (igual criterio que el backend)
        const porId = new Map();
        filas.forEach(f => porId.set(f.IdMaterialETL, f));
        const finales = Array.from(porId.values());

        this.importPreview = {
          totalLeidas: rows.length,
          aplicables: finales.length,
          sinMatch,
          categoriaInvalida,
          duplicados,
          incompletas,
          categoriasInvalidas: Array.from(invalidas).slice(0, 50),
          filas: finales,
        };
      } catch (e) {
        console.error('[onImportCategoriasFile] error:', e);
        this.importError = (e && e.message) ? e.message : this.$t('import_error_generico');
      } finally {
        this.isImportParsing = false;
      }
    },

    async aplicarImportCategorias() {
      if (!this.puedeEditarArchivo) return;
      if (!this.importPreview || !this.importPreview.aplicables) return;

      const confirm = await Swal.fire({
        title: this.$t('import_confirmar_titulo'),
        text: this.$t('import_confirmar_texto', { n: this.importPreview.aplicables }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_aplicar') || 'Sí, aplicar',
        cancelButtonText: this.$t('cancelar'),
      });
      if (!confirm.isConfirmed) return;

      const token = this.$route.params.token;
      this.isBulkApplying = true;

      try {
        const resp = await materialService.importCategorias(token, this.importPreview.filas);
        const r = (resp && resp.result) ? resp.result : {};

        this.showImportCategoriasModal = false;
        this.importPreview = null;

        await this.fetchAll(token);
        await this.refreshKpis();

        const omitidas = (r.omitidasPorCategoria || 0) + (r.omitidasPorToken || 0) + (r.omitidasPorDatosIncompletos || 0);
        Swal.fire(
          this.$t('exito'),
          this.$t('import_resultado', { n: r.actualizadas || 0, omitidas }),
          'success'
        );
      } catch (e) {
        console.error('[importCategorias] error:', e);
        Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
      } finally {
        this.isBulkApplying = false;
      }
    },

    async aplicarMasivoTodos(tipo, valor) {
      if (!this.puedeEditarArchivo) return false;
      const confirm = await Swal.fire({
        title: this.$t('confirmar_aplicar_todos') || '¿Aplicar a todos los registros?',
        text: this.$t('confirmar_aplicar_todos_texto') || 'Esto actualizará de inmediato TODOS los registros del archivo directamente en la base de datos, sin pasar por el guardado individual. Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_aplicar') || 'Sí, aplicar',
        cancelButtonText: this.$t('cancelar'),
      });
      if (!confirm.isConfirmed) return false;

      const token = this.$route.params.token;
      this.isBulkApplying = true;

      try {
        await materialService.updateEtlBulk(token, tipo, valor != null ? String(valor) : null);
        await this.fetchAll(token);
        await this.refreshKpis();
        Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), 'success');
        return true;
      } catch (e) {
        console.error('[updateEtlBulk] error:', e);
        Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
        return false;
      } finally {
        this.isBulkApplying = false;
      }
    },

    async aplicarCategoriaSeleccionada() {
      if (!this.puedeEditarArchivo) return;
      if (!this.selectedCategoria) return;

      if (this.categoriaApplyScope === 'all') {
        const ok = await this.aplicarMasivoTodos('Categoria', this.selectedCategoria);
        if (ok) {
          this.showSelectedModal = false;
          this.selectedCategoria = null;
          this.categoriaApplyScope = 'selected';
        }
        return;
      }

      this.etl.forEach(item => {
        if (this.checkedIds.includes(item.idMaterialETL)) {
          item.categoriaInexlink = this.selectedCategoria;
          // item.categoria_MM = this.selectedCategoria; // 🔁 espejo en UI
          this.applyTaxToItem(item, this.selectedCategoria); //sincroniza clase/segmento/familia

          item.showGuardar = true;
          item.userModified = true;
          item.confianza = this.getConfianzaValue(item.top5Predicciones, item.categoriaInexlink);
        }
      });
      this.showSelectedModal = false;
      this.selectedCategoria = null;
      this.checkedIds = []; // Limpia los checks seleccionados

      // Mensaje informativo
      this.$nextTick(() => {
        Swal.fire(
          this.$t('modal_informacion'),
          this.$t('modal_asignacion_categorias_recordatorio'),
          'info'
        );
      });
    },

    async aplicarCondicionSeleccionada() {
      if (!this.puedeEditarArchivo) return;
      if (!this.selectedCondicion) return;

      if (this.condicionApplyScope === 'all') {
        const ok = await this.aplicarMasivoTodos('Condicion', this.selectedCondicion);
        if (ok) {
          this.showCondicionModal = false;
          this.selectedCondicion = null;
          this.condicionApplyScope = 'selected';
        }
        return;
      }

      this.etl.forEach(item => {
        if (this.checkedIdsCondicion.includes(item.idMaterialETL)) {
          item.idCondicion = this.selectedCondicion;
          item.showGuardar = true;
          item.userModified = true;
        }
      });
      this.showCondicionModal = false;
      this.selectedCondicion = null;
      this.checkedIdsCondicion = []; // Limpia los checks seleccionados

      // Mensaje informativo
      this.$nextTick(() => {
        Swal.fire(
          this.$t('modal_informacion'),
          this.$t('modal_asignacion_condicion_recordatorio'),
          'info'
        );
      });
    },

    async aplicarUomSeleccionada() {
      if (!this.puedeEditarArchivo) return;
      if (!this.selectedUom) return;

      if (this.uomApplyScope === 'all') {
        const ok = await this.aplicarMasivoTodos('UOM', this.selectedUom);
        if (ok) {
          this.showUomModal = false;
          this.selectedUom = null;
          this.uomApplyScope = 'selected';
        }
        return;
      }

      this.etl.forEach(item => {
        if (this.checkedIdsUom.includes(item.idMaterialETL)) {
          item.idUnidadDeMedida = this.selectedUom;
          item.showGuardar = true;
          item.userModified = true;
        }
      });
      this.showUomModal = false;
      this.selectedUom = null;
      this.checkedIdsUom = []; // Limpia los checks seleccionados

      // Mensaje informativo
      this.$nextTick(() => {
        Swal.fire(
          this.$t('modal_informacion'),
          this.$t('modal_asignacion_uom_recordatorio'),
          'info'
        );
      });
    },

    async aplicarBrandNameSeleccionada() {
      if (!this.puedeEditarArchivo) return;

      // Texto libre: se normaliza el espacio y se acepta vacío, que deja el fabricante en blanco.
      const valor = (this.selectedBrandName || '').trim();

      if (this.brandNameApplyScope === 'all') {
        const ok = await this.aplicarMasivoTodos('BrandName', valor || null);
        if (ok) {
          this.showBrandNameModal = false;
          this.selectedBrandName = '';
          this.brandNameApplyScope = 'selected';
        }
        return;
      }

      this.etl.forEach(item => {
        if (this.checkedIdsBrandName.includes(item.idMaterialETL)) {
          item.brandName = valor;
          item.showGuardar = true;
          item.userModified = true;
        }
      });
      this.showBrandNameModal = false;
      this.selectedBrandName = '';
      this.checkedIdsBrandName = []; // Limpia los checks seleccionados

      // Mensaje informativo
      this.$nextTick(() => {
        Swal.fire(
          this.$t('modal_informacion'),
          this.$t('modal_asignacion_fabricante_recordatorio'),
          'info'
        );
      });
    },

    async ejecutarRentabilizacion() {
      if (!this.puedeEditarArchivo) return;
      const token = this.$route.params.token;
      try {
        const response = await materialService.updateEstadoFlujo(token, 'S');
        if (response && (response.success === true || response.Success === true)) {
          this.$set(this.archivo, 'estadoFlujo', 'S');
          const result = await Swal.fire({
            icon: 'success',
            title: this.$t('exito') || 'Éxito',
            text: this.$t('en_proceso') || 'El proceso de rentabilización ha sido iniciado.',
            showCancelButton: true,
            confirmButtonText: this.$t('ir_al_detalle') || 'Ir al detalle',
            cancelButtonText: this.$t('cancelar') || 'Cancelar',
          });
          if (result.isConfirmed) {
            this.$router.push({ path: '/rentabilizacion', query: { empresa: this.empresaId } });
          }
        } else {
          Swal.fire('Error', this.$t('no_se_pudo_guardar') || 'No se pudo iniciar el proceso.', 'error');
        }
      } catch (error) {
        console.error('Error al ejecutar rentabilización:', error);
        Swal.fire('Error', this.$t('no_se_pudo_guardar') || 'Ocurrió un error al ejecutar el proceso.', 'error');
      }
    },

    // Solo aplica al flujo "NR" (Directo a Cluster): salta la rentabilización y
    // manda el archivo directo al estado 'C', igual que el botón de ClusterizacionView.
    async ejecutarClusterizacion() {
      if (!this.puedeEditarArchivo || !this.esFlujoDirectoCluster) return;
      const token = this.$route.params.token;
      try {
        const response = await materialService.updateEstadoFlujo(token, 'C');
        if (response && (response.success === true || response.Success === true)) {
          this.$set(this.archivo, 'estadoFlujo', 'C');
          const result = await Swal.fire({
            icon: 'success',
            title: this.$t('exito') || 'Éxito',
            text: this.$t('clusterizacion_iniciada') || 'El proceso de clusterización ha sido iniciado.',
            showCancelButton: true,
            confirmButtonText: this.$t('ir_al_detalle') || 'Ir al detalle',
            cancelButtonText: this.$t('cancelar') || 'Cancelar',
          });
          if (result.isConfirmed) {
            this.$router.push({ path: '/clusterizacion', query: { empresa: this.empresaId } });
          }
        } else {
          Swal.fire('Error', this.$t('no_se_pudo_guardar') || 'No se pudo iniciar el proceso.', 'error');
        }
      } catch (error) {
        console.error('Error al ejecutar clusterización:', error);
        Swal.fire('Error', this.$t('no_se_pudo_guardar') || 'Ocurrió un error al ejecutar el proceso.', 'error');
      }
    },
  }
};
</script>

<style scoped>
input.form-control.inpt_result.id_pro {
  width: 100px;
}

.table {
  font-size: 0.9rem;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.table tbody tr:hover td {
  border-top: 2px solid #6c757d !important;
  border-bottom: 2px solid #6c757d !important;
}

.text-primary {
  color: #007bff !important;
}

.text-secondary {
  color: #6c757d !important;
}

.card {
  border: none;
  border-radius: 0.5rem;
  background-color: #f8f9fa;
}

.card h4 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.card p {
  font-size: 1rem;
  margin: 0;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.row.text-center {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.row.text-center .col {
  display: inline-block;
  text-align: center;
  margin: 0 10px;
}

.row.text-center .col h4 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.row.text-center .col p {
  font-size: 1rem;
  margin: 0;
}

.d-flex.justify-content-start.align-items-center.mb-3.gap-4 span {
  font-size: 1.2rem;
  font-weight: 500;
}

/* Adjust spacing in the sidebar */
.sidebar .nav-item {
  margin-bottom: 0.5rem;
  /* Reduce spacing between items */
}

.bg-danger {
  background-color: #f8d7da !important;
}

input.el-input__inner {
  font-size: 0.7rem !important;
  border-radius: 6px !important;
}

input.form-control.inpt_result {
  font-size: 0.7rem !important;
  border-radius: 6px !important;
  padding: 0.2rem 0.3rem !important;
  height: auto !important;

}

.td-top input {
  font-size: 0.7rem !important;
  border-radius: 6px !important;
}

.float-right {
  float: right;
}

.c-grey {
  color: rgb(95, 94, 94) !important;
}

.bg-circle-1 {
  background: #007bff33;
  padding: 10px;
  border-radius: 25px;
  color: #408ae6;
}

.bg-circle-2 {
  background: #e6b7303b;
  padding: 10px;
  border-radius: 25px;
  color: #ffbf09;
}

.bg-circle-3 {
  background: #ffb30059;
  padding: 10px;
  border-radius: 25px;
  color: #e68b40;
}

.bg-circle-4 {
  background: #ad00d529;
  padding: 10px;
  border-radius: 25px;
  color: #ad00d5;
}

.bg-circle-5 {
  background: #03823433;
  padding: 10px;
  border-radius: 25px;
  color: #018234;
}

.table th,
.table td {
  padding: 0.1rem 0.5rem !important;
}

@media (min-width: 768px) {
  .main-content .container-fluid {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

input[type=radio],
input[type=checkbox] {
  margin-top: 13px;
}

label.fw-bold.me-2 {
  padding: 10px;
  margin-top: 5px;
}

.d-flex.align-items-center.gap-3.mb-2 {
  float: right;
}

.loading-backdrop {
  position: fixed;
  z-index: 900;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-box {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: #ffffff;
  border: 1px solid #e3e6eb;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  font-weight: 600;
  color: #2f3b52;
}

.highlight-column {
  background-color: #dee2e6 !important;
}
.highlight-column2 {
  background-color: rgb(236, 240, 240)!important;
}

/* Celda con cambio pendiente de guardar.
   Se usa td.celda-modificada (mayor especificidad que .bg-danger y .highlight-column,
   ambas con !important) para que el amarillo mande mientras el cambio no se guarde. */
td.celda-modificada {
  background-color: #fff3cd !important;
  box-shadow: inset 0 0 0 2px #f0ad4e;
}

/* Marca al inicio de la fila: la tabla es ancha y con scroll horizontal la celda
   amarilla puede quedar fuera de la vista. */
tr.fila-modificada > td:first-child {
  border-left: 4px solid #f0ad4e !important;
}

/* Aviso de cambios pendientes, junto al filtro de color */
/* Contador de filas filtradas en el pie: informativo, no es un boton. */
.badge-filtrados {
  background-color: #e7f5ff;
  border: 1px solid #74c0fc;
  border-radius: 6px;
  color: #1971c2;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 5px 10px;
  white-space: nowrap;
}

.alerta-solo-lectura {
  background-color: #e2e3e5;
  border: 1px solid #adb5bd;
  border-radius: 6px;
  color: #41464b;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 6px 10px;
  white-space: nowrap;
  margin-right: 1.5rem;
}

.alerta-sin-guardar {
  background-color: #fff3cd;
  border: 1px solid #f0ad4e;
  border-radius: 6px;
  color: #8a6d3b;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 6px 10px;
  white-space: nowrap;
  /* separación del bloque "Filtrar por" (el gap del contenedor es muy justo) */
  margin-right: 1.5rem;
}

.icono-palpita {
  color: #e0a800;
  animation: palpita 1.1s ease-in-out infinite;
}

@keyframes palpita {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.45; }
}

/* Respeta la preferencia del sistema de reducir animaciones */
@media (prefers-reduced-motion: reduce) {
  .icono-palpita { animation: none; }
}

.table-scroll-container {
  overflow-x: auto;
  overflow-y: clip;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* La barra de paginación es position:fixed y flota sobre el final de la
     página. Sin esta reserva la última fila queda tapada por ella. */
  margin-bottom: 60px;
}

.table-scroll-container::-webkit-scrollbar {
  display: none;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-ordenable:active {
  background-color: #dee2e6 !important;
}

.th-search-input {
  margin-bottom: 6px;
}

.btn-modificar-categoria {
  width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;
}

.btn-importar-categoria {
  flex: 0 0 auto;
  padding: 2px 8px;
  line-height: 1.2;
}

.th-label {
  display: block;
  font-size: 0.65rem;
  font-weight: 600;
  line-height: 1.3;
}

.thead-sticky {
  will-change: transform;
  position: relative;
  z-index: 100;
}

.thead-behind-modal {
  z-index: 1 !important;
  will-change: auto !important;
}

.thead-sticky th {
  background-color: #f8f9fa;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  border-top: none;
  border-bottom: none;
  box-shadow: inset 0 3px 0 #a0a3a5, inset 0 -3px 0 #a0a3a5;
}

.inpt-partname {
  border: 1px solid #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.inpt-partname:hover {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.inpt-partname:focus {
  border-color: #0056b3;
  box-shadow: 0 0 0 3px rgba(0, 86, 179, 0.3);
  outline: none;
}

.badge-coincidencia {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0.15rem 0.3rem;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-exacto {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.badge-parcial {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.badge-sin-coincidencia {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.badge-vacio {
  background-color: #e9ecef;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.label-tipomatch {
  font-size: 0.65rem;
  color: #495057;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}

.select-compact ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 0 24px 0 8px;
  font-size: 0.78rem;
}

.select-compact ::v-deep .el-input__suffix {
  line-height: 28px;
}

.el-select-categoria ::v-deep .el-input__inner {
  border: 1px solid #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  padding: 0.2rem 0.3rem !important;
}

.el-select-categoria ::v-deep .el-input__inner:hover {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  padding: 0.2rem 0.3rem !important;
}

.el-select-categoria ::v-deep .el-input__inner:focus {
  border-color: #0056b3;
  box-shadow: 0 0 0 3px rgba(0, 86, 179, 0.3);
  padding: 0.2rem 0.3rem !important;
}

/* Barra flotante de paginación */
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}

.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #212529;
}

::v-deep .opt-ia {
  background-color: #f0fdf4 !important;
}
::v-deep .opt-ia.hover {
  background-color: #dcfce7 !important;
}
::v-deep .opt-ia.selected {
  background-color: #bbf7d0 !important;
  color: #15803d !important;
  font-weight: 600;
}
</style>
